import React from 'react';
import '../template-file-css/document-file-template.css';


export const NP_AdultBha = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NP_AdultBha' className='file-pdf-document'>
            <div className='file-template'>


                <h3>A.	ASSESSMENT INFORMATION (COMPLETE ALL INFORMATION)</h3>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'> Individual Name: </span></td>
                        <td className='w-250'><span className='eleHeader'> Assessment Date:</span></td>
                        <td className='w-250'><span className='eleHeader'> Assessor Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type="text" id="txtIndividualName" name="txtIndividualName" className='add-only' />  </td>
                        <td className='w-250'> <input type="date" id="txtAssessmentDate" name="txtAssessmentDate" className='add-only' />  </td>
                        <td className='w-250'> <input type="text" id="txtAssessorName" name="txtAssessorName" className='add-only' />  </td>
                    </tr>
                </table>

                <p>
                    <input type="radio" id="rb_InitialAssessment" name="rbAssessment" className='add-only' value="InitialAssessment" />  Initial Assessment
                    &nbsp;
                    <input type="radio" id="rb_ReAssessment" name="rbAssessment" className='add-only' value="ReAssessment" />  Re-Assessment
                </p>

                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Parent/Guardian:</span></td>
                        <td className='w-250'><span className='eleHeader'>Home Telephone:</span></td>
                        <td className='w-250'><span className='eleHeader'>Cell Phone:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtParent" name="txtParent" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtHomeTelephone" name="txtHomeTelephone" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtCellTelephone" name="txtCellTelephone" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Address:</span>
                    <textarea id="txtAddress" name="txtAddress" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>City:</span></td>
                        <td className='w-250'><span className='eleHeader'>State:</span></td>
                        <td className='w-250'><span className='eleHeader'>Zip code:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtCity" name="txtCity" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtState" name="txtState" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtZip" name="txtZip" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Individual DOB:</span></td>
                        <td className='w-250'><span className='eleHeader'>Age</span></td>
                        <td className='w-250'><span className='eleHeader'>Race/Ethnicity</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtIndividual" name="txtIndividual" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtAge" name="txtAge" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txRacet" name="txRacet" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Sex assigned at birth:</span>

                    <input type="radio" id="rb_Male" name="rbSexAtBirth" className='add-only' value="Male" />  Male &nbsp;
                    <input type="radio" id="rb_Female" name="rbSexAtBirth" className='add-only' value="Female" />  Female &nbsp;
                    <input type="radio" id="rb_Intersex" name="rbSexAtBirth" className='add-only' value="Intersex" />  Intersex
                </p>
                <p>
                    <span className='eleHeader'>What is your gender?</span>
                    <input type="radio" id="rbGender_Male" name="rbGender" className='add-only' value="Male" />  Male &nbsp;
                    <input type="radio" id="rbGender_Female" name="rbGender" className='add-only' value="Female" />  Female &nbsp;
                    <input type="radio" id="rbGender_NonBinary" name="rbGender" className='add-only' value="NonBinary" />  Non-binary/third gender &nbsp;
                    <input type="radio" id="rbGender_PreferDescribe" name="rbGender" className='add-only' value="PreferDescribe" />  Prefer to self-describe &nbsp;
                    <input type="text" className='w-250 add-only' id="txtGender_PreferDescribe" name="txtGender_PreferDescribe" />
                </p>
                <p>
                    <strong>Emergency Contact</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Name:</span></td>
                        <td className='w-250'><span className='eleHeader'>Relationship:</span></td>
                        <td className='w-250'><span className='eleHeader'>Contact Telephone:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtName" name="txtName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRelationship" name="txtRelationship" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtContact" name="txtContact" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>INSURANCE INFORMATION</strong>
                </p>
                <table>
                    <tr>
                        <td className="w-750"><span className='eleHeader'>Insurance Type</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbInsuranceType_1" name="cbInsuranceType_1" className='add-only' value="InsuranceType_1" /> Medicaid Standard:
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbInsuranceType_2" name="cbInsuranceType_2" className='add-only' value="InsuranceType_2" /> Cenpatico:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtInsuranceType_1" name="txtInsuranceType_1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtInsuranceType_2" name="txtInsuranceType_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbInsuranceType_3" name="cbInsuranceType_3" className='add-only' value="InsuranceType_3" /> Amerigroup:
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbInsuranceType_4" name="cbInsuranceType_4" className='add-only' value="InsuranceType_4" /> Ambetter:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtInsuranceType_3" name="txtInsuranceType_3" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtInsuranceType_4" name="txtInsuranceType_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbInsuranceType_5" name="cbInsuranceType_5" className='add-only' value="InsuranceType_5" /> Caresource:
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbInsuranceType_6" name="cbInsuranceType_6" className='add-only' value="InsuranceType_6" /> Other:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtInsuranceType_5" name="txtInsuranceType_5" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtInsuranceType_6" name="txtInsuranceType_6" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>B.	INDIVIDUAL PRESENTATION & PRESENTING PROBLEM</h3>
                <p>
                    <span className='eleHeader'>Location of assessment?</span>
                    <textarea id="txtLocationAssessment" name="txtLocationAssessment" className='add-only'></textarea>
                    <span className='eleHeader'>Who was present during assessment?</span>
                    <textarea id="txtPresentAssessment" name="txtPresentAssessment" className='add-only'></textarea>
                </p>
                <h3>C.	MENTAL STATUS EXAM<span className='small'>(Check all that apply)</span></h3>
                <p>

                    <span className='eleHeader'>General Appearance</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbGeneralAppearance_1" name="cbGeneralAppearance_1" className='add-only' value="GeneralAppearance_1" /> Overweight
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbGeneralAppearance_2" name="cbGeneralAppearance_2" className='add-only' value="GeneralAppearance_2" /> Frail
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbGeneralAppearance_3" name="cbGeneralAppearance_3" className='add-only' value="GeneralAppearance_3" /> Lean
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbGeneralAppearance_4" name="cbGeneralAppearance_4" className='add-only' value="GeneralAppearance_4" /> Muscular
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbGeneralAppearance_5" name="cbGeneralAppearance_5" className='add-only' value="GeneralAppearance_5" /> Neat
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Behavior</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_1" name="cbBehavior_1" className='add-only' value="Behavior_1" /> Older than age
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_2" name="cbBehavior_2" className='add-only' value="Behavior_2" /> Younger than age
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_3" name="cbBehavior_3" className='add-only' value="Behavior_3" /> Sloppy
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_4" name="cbBehavior_4" className='add-only' value="Behavior_4" /> Slumped
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_5" name="cbBehavior_5" className='add-only' value="Behavior_5" /> Cooperative
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_6" name="cbBehavior_6" className='add-only' value="Behavior_6" /> Open
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_7" name="cbBehavior_7" className='add-only' value="Behavior_7" /> Irritable
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_8" name="cbBehavior_8" className='add-only' value="Behavior_8" /> Anxious
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_9" name="cbBehavior_9" className='add-only' value="Behavior_9" /> Calm
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_10" name="cbBehavior_10" className='add-only' value="Behavior_10" /> Combative
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_11" name="cbBehavior_11" className='add-only' value="Behavior_11" /> Agitated
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbBehavior_12" name="cbBehavior_12" className='add-only' value="Behavior_12" /> Defensive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbBehavior_13" name="cbBehavior_13" className='add-only' value="Behavior_13" /> Other :
                            <input type="text" id="txtBehavior_13" name="txtBehavior_13" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>If risk exists, Individual is able to contract not to harm:</span>
                    <input type="checkbox" id="cbRiskExists_1" name="cbRiskExists_1" className='add-only' value="RiskExists_1" />  Self &nbsp;
                    <br />
                    <input type="checkbox" id="cbRiskExists_2" name="cbRiskExists_2" className='add-only' value="RiskExists_2" />  Others :
                    <input type="text" id="txtRiskExists_2" name="txtRiskExists_2" className='w-250 add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Mood/Affect</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_1" name="cbMood_1" className='add-only' value="Mood_1" /> Appropriate
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_2" name="cbMood_2" className='add-only' value="Mood_2" /> Apathetic
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_3" name="cbMood_3" className='add-only' value="Mood_3" /> Euphoric
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_4" name="cbMood_4" className='add-only' value="Mood_4" /> Angry
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_5" name="cbMood_5" className='add-only' value="Mood_5" /> Flat
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_6" name="cbMood_6" className='add-only' value="Mood_6" /> Hostile
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_7" name="cbMood_7" className='add-only' value="Mood_7" /> Sad
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbMood_8" name="cbMood_8" className='add-only' value="Mood_8" /> Tearful
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_9" name="cbMood_9" className='add-only' value="Mood_9" /> Other :
                            <input type="text" id="txtMood_9" name="txtMood_9" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Speech</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_1" name="cbSpeech_1" className='add-only' value="Speech_1" /> Normal Limits
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_2" name="cbSpeech_2" className='add-only' value="Speech_2" /> Rapid
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_3" name="cbSpeech_3" className='add-only' value="Speech_3" /> Stuttering
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_4" name="cbSpeech_4" className='add-only' value="Speech_4" /> Slurred
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_5" name="cbSpeech_5" className='add-only' value="Speech_5" /> Soft
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_6" name="cbSpeech_6" className='add-only' value="Speech_6" /> Pressured
                        </td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_7" name="cbSpeech_7" className='add-only' value="Speech_7" /> Others :
                            <input type="text" id="txtSpeech_7" name="txtSpeech_7" className='add-only w-250' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Thought Process</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_1" name="cbThoughtProcess_1" className='add-only' value="ThoughtProcess_1" /> Logical
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_2" name="cbThoughtProcess_2" className='add-only' value="ThoughtProcess_2" /> Grandiose
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_3" name="cbThoughtProcess_3" className='add-only' value="ThoughtProcess_3" /> Paranoid
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_4" name="cbThoughtProcess_4" className='add-only' value="ThoughtProcess_4" /> Unorganized
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_5" name="cbThoughtProcess_5" className='add-only' value="ThoughtProcess_5" /> Loose
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_6" name="cbThoughtProcess_6" className='add-only' value="ThoughtProcess_6" /> Delusional
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThoughtProcess_7" name="cbThoughtProcess_7" className='add-only' value="ThoughtProcess_7" /> Tangential
                        </td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_8" name="cbThoughtProcess_8" className='add-only' value="ThoughtProcess_8" /> Other :
                            <input type="text" id="txtThoughtProcess_8" name="txtThoughtProcess_8" className='add-only  w-250' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Perception</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPerception_1" name="cbPerception_1" className='add-only' value="Perception_1" /> Normal Limits
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPerception_2" name="cbPerception_2" className='add-only' value="Perception_2" /> Auditory Hallucinations
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPerception_3" name="cbPerception_3" className='add-only' value="Perception_3" /> Visual Hallucinations
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbPerception_4" name="cbPerception_4" className='add-only' value="Perception_4" /> Tactile Hallucinations
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPerception_5" name="cbPerception_5" className='add-only' value="Perception_5" /> Other :
                            <input type="text" id="txtPerception_5" name="txtPerception_5" className='add-only  w-250' />
                        </td>

                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Orientation</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOrientation_1" name="cbOrientation_1" className='add-only' value="Orientation_1" /> To person
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOrientation_2" name="cbOrientation_2" className='add-only' value="Orientation_2" /> To place
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOrientation_3" name="cbOrientation_3" className='add-only' value="Orientation_3" /> To situation
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOrientation_4" name="cbOrientation_4" className='add-only' value="Orientation_4" /> To time
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOrientation_5" name="cbOrientation_5" className='add-only' value="Orientation_5" /> Disoriented
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Memory</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemory_1" name="cbMemory_1" className='add-only' value="Memory_1" /> Recent intac Can repeat 3 digitst
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemory_2" name="cbMemory_2" className='add-only' value="Memory_2" /> Remote intact ( can provide history)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemory_3" name="cbMemory_3" className='add-only' value="Memory_3" /> Recent not intact
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemory_4" name="cbMemory_4" className='add-only' value="Memory_4" /> Remote not intact
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMemory_5" name="cbMemory_5" className='add-only' value="Memory_5" /> Other :
                            <input type="text" id="txtMemory_5" name="txtMemory_5" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Insight into illness/life situation</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbInsight_1" name="cbInsight_1" className='add-only' value="Insight_1" /> Unimpaired
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbInsight_2" name="cbInsight_2" className='add-only' value="Insight_2" /> Limited
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbInsight_3" name="cbInsight_3" className='add-only' value="Insight_3" /> Absent
                        </td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbInsight_4" name="cbInsight_4" className='add-only' value="Insight_4" /> Other :
                            <input type="text" id="txtInsight_4" name="txtInsight_4" className='add-only' />
                        </td>
                    </tr>

                </table>
                <p>
                    <span className='eleHeader'>Suicidal Ideation:</span>
                    <input type="radio" id="rbSuicidalIdeation_Yes" name="rbSuicidalIdeation" className='add-only' value="Yes" />  Yes &nbsp;
                    <input type="radio" id="rbSuicidalIdeation_No" name="rbSuicidalIdeation" className='add-only' value="No" />  No
                    <br />
                    <strong>If yes:  Suicide Plan</strong>
                    <input type="radio" id="rbSuicidalIdeationYes_Yes" name="rbSuicidalIdeationYes" className='add-only' value="Yes" />  Yes &nbsp;
                    <input type="radio" id="rbSuicidalIdeationYes_No" name="rbSuicidalIdeationYes" className='add-only' value="No" />  No
                    <span className='eleHeader'>Homicidal Ideation:</span>
                    <input type="radio" id="rbHomicidalIdeations_Yes" name="rbHomicidalIdeations" className='add-only' value="Yes" />  Yes &nbsp;
                    <input type="radio" id="rbHomicidalIdeations_No" name="rbHomicidalIdeations" className='add-only' value="No" />  No
                    <br />
                    <strong>If yes:  Homicide Plan</strong>
                    <input type="radio" id="rbHomicidalIdeationsYes_Yes" name="rbHomicidalIdeationsYes" className='add-only' value="Yes" />  Yes &nbsp;
                    <input type="radio" id="rbHomicidalIdeationsYes_No" name="rbHomicidalIdeationsYes" className='add-only' value="No" />  No
                </p>
                <p>
                    <span className='eleHeader'>Mental Status:</span>
                    <span className='small'>(Describe Individual's mood, affect, thought processes, though contact, AVH, intelligence, insight, judgment, and orientation)</span>
                    <textarea id="txtMentalStatus" name="txtMentalStatus" className='add-only'></textarea>
                </p>
                <h3>D. PRESENTING PROBLEM AND REQUESTED SERVICE</h3>
                <p>
                    <span className='eleHeader'>What is the Individual's presenting problem / Diagnostic Criteria:</span>
                    <span className='small'>This should be in the Individual's own words as well as Assessor's description of Clinical Criteria met for DSM-5 dx per Individual's input:</span>
                    <textarea id="txtIndividualPresentingProblem" name="txtIndividualPresentingProblem" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Origin of problem/when it began:</span>
                    <span className='small'>Include the onset of the problem, duration, frequency, past intervention/services and the results of the services.</span>
                    <textarea id="txtOriginProblem" name="txtOriginProblem" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Related Issues that exacerbate the problem:</span>
                    <textarea id="txtRelatedIssues" name="txtRelatedIssues" className='add-only'></textarea>
                </p>

                <h3>E.	MEDICAL AND BEHAVIORAL HEALTH HISTORY</h3>
                <p>
                    List all major illness, surgeries, major injuries. Begin with most recent and work backwards
                </p>


                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Past Conditions </span></td>
                        <td className='w-250'><span className='eleHeader'>Date of Onset </span></td>
                        <td className='w-250'><span className='eleHeader'>Residual Effects </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPast_1" name="txtPast_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateOf_1" name="txtDateOf_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtResidual_1" name="txtResidual_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPast_2" name="txtPast_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateOf_2" name="txtDateOf_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtResidual_2" name="txtResidual_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPast_3" name="txtPast_3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateOf_3" name="txtDateOf_3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtResidual_3" name="txtResidual_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPast_4" name="txtPast_4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateOf_4" name="txtDateOf_4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtResidual_4" name="txtResidual_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPast_5" name="txtPast_5" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateOf_5" name="txtDateOf_5" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtResidual_5" name="txtResidual_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPast_6" name="txtPast_6" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateOf_6" name="txtDateOf_6" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtResidual_6" name="txtResidual_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPast_7" name="txtPast_7" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateOf_7" name="txtDateOf_7" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtResidual_7" name="txtResidual_7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPast_8" name="txtPast_8" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateOf_8" name="txtDateOf_8" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtResidual_8" name="txtResidual_8" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPast_9" name="txtPast_9" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateOf_9" name="txtDateOf_9" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtResidual_9" name="txtResidual_9" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPast_10" name="txtPast_10" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateOf_10" name="txtDateOf_10" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtResidual_10" name="txtResidual_10" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>F.	MEDICAL ASSESSMENT</h3>
                <p>
                    <span className='eleHeader'>What medical problems does the Individual have?
                    </span>
                    <span className='small'>(Include specific diagnosis, when problem was diagnosed, interventions)</span>
                    <textarea id="txtMedicalProblems" name="txtMedicalProblems" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>PRESCRIBED MEDICATIONS
                    </span>
                    <span className='small'>(Include both medical and psychiatric medications)
                    </span>
                    <input type="checkbox" id="cbPrescribedNone" name="cbPrescribedNone" className='add-only' value="None" /> None
                </p>

                <p><strong>(1)</strong></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Frequency	</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribed by?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicationName_1" name="txtMedicationName_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDose_1" name="txtDose_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrescribed_1" name="txtPrescribed_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-250'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-250'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWhenPrescribed_1" name="txtWhenPrescribed_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRefill_1" name="txtRefill_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSideEffects_1" name="txtSideEffects_1" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>(2)</strong></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Frequency	</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribed by?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicationName_2" name="txtMedicationName_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDose_2" name="txtDose_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrescribed_2" name="txtPrescribed_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-250'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-250'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWhenPrescribed_2" name="txtWhenPrescribed_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRefill_2" name="txtRefill_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSideEffects_2" name="txtSideEffects_2" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>(3)</strong></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Frequency	</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribed by?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicationName_3" name="txtMedicationName_3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDose_3" name="txtDose_3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrescribed_3" name="txtPrescribed_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-250'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-250'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWhenPrescribed_3" name="txtWhenPrescribed_3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRefill_3" name="txtRefill_3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSideEffects_3" name="txtSideEffects_3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>(4)</strong></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Frequency	</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribed by?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicationName_4" name="txtMedicationName_4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDose_4" name="txtDose_4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrescribed_4" name="txtPrescribed_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-250'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-250'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWhenPrescribed_4" name="txtWhenPrescribed_4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRefill_4" name="txtRefill_4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSideEffects_4" name="txtSideEffects_4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>(5)</strong></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Frequency	</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribed by?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicationName_5" name="txtMedicationName_5" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDose_5" name="txtDose_5" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrescribed_5" name="txtPrescribed_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-250'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-250'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWhenPrescribed_5" name="txtWhenPrescribed_5" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRefill_5" name="txtRefill_5" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSideEffects_5" name="txtSideEffects_5" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>(6)</strong></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Frequency	</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribed by?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicationName_6" name="txtMedicationName_6" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDose_6" name="txtDose_6" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrescribed_6" name="txtPrescribed_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-250'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-250'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWhenPrescribed_6" name="txtWhenPrescribed_6" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRefill_6" name="txtRefill_6" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSideEffects_6" name="txtSideEffects_6" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>(7)</strong></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Frequency	</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribed by?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicationName_7" name="txtMedicationName_7" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDose_7" name="txtDose_7" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrescribed_7" name="txtPrescribed_7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-250'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-250'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWhenPrescribed_7" name="txtWhenPrescribed_7" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRefill_7" name="txtRefill_7" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSideEffects_7" name="txtSideEffects_7" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>(8)</strong></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Frequency	</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribed by?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicationName_8" name="txtMedicationName_8" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDose_8" name="txtDose_8" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrescribed_8" name="txtPrescribed_8" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-250'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-250'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWhenPrescribed_8" name="txtWhenPrescribed_8" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRefill_8" name="txtRefill_8" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSideEffects_8" name="txtSideEffects_8" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>(9)</strong></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Frequency	</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribed by?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicationName_9" name="txtMedicationName_9" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDose_9" name="txtDose_9" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrescribed_9" name="txtPrescribed_9" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-250'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-250'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWhenPrescribed_9" name="txtWhenPrescribed_9" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRefill_9" name="txtRefill_9" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSideEffects_9" name="txtSideEffects_9" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>(10)</strong></p>


                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Frequency	</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribed by?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicationName_10" name="txtMedicationName_10" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDose_10" name="txtDose_10" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrescribed_10" name="txtPrescribed_10" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-250'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-250'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWhenPrescribed_10" name="txtWhenPrescribed_10" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRefill_10" name="txtRefill_10" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSideEffects_10" name="txtSideEffects_10" className='add-only' />
                        </td>
                    </tr>
                </table>


                <p>
                    <span className='eleHeader'>Is Individual compliant with medications?</span>
                    <input type="radio" id="rbCompliant_Yes" name="rbCompliant" className='add-only' value="Compliant_Yes" />  Yes &nbsp;
                    <input type="radio" id="rbCompliant_No" name="rbCompliant" className='add-only' value="Compliant_No" />  No &nbsp;
                    <input type="radio" id="rbCompliant_Explain" name="rbCompliant" className='add-only' value="Compliant_Explain" /> Explain:
                    <input type="text" id="txtCompliant_Explain" name="txtCompliant_Explain" className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Current Primary Care Physician:</span></td>
                        <td className='w-375'><span className='eleHeader'>Telephone No.:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtPrimaryCarePhysician" name="txtPrimaryCarePhysician" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtPhysicianTelephone" name="txtPhysicianTelephone" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Current Psychiatrist:</span></td>
                        <td className='w-375'><span className='eleHeader'>Telephone No.:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtCurrentPsychiatrist" name="txtCurrentPsychiatrist" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtPsychiatristTelephone" name="txtPsychiatristTelephone" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Date of last PCP Visit:</span></td>
                        <td className='w-250'><span className='eleHeader'>Date of last Dental Visit: </span></td>
                        <td className='w-250'><span className='eleHeader'>Date of last Vision Exam: </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtDatePcp" name="txtDatePcp" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateDental" name="txtDateDental" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateVision" name="txtDateVision" className='add-only' />
                        </td>
                    </tr>
                </table>

                <h3>G.	PAIN ASSESSMENT</h3>
                <p>
                    <span className='eleHeader'>What current pain does the Individual have?</span>
                    <span className='small'>(Include specific diagnosis, when problem was diagnosed, interventions)
                    </span>
                    <input type="checkbox" id="cbPainIndividualNone" name="cbPainIndividualNone" className='add-only' value="None" /> None
                </p>
                <p>
                    <textarea id="txtCurrentPain" name="txtCurrentPain" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>PRESCRIBED PAIN MEDICATIONS</span>
                    <span className='small'>(Include both prescribed and over the counter medications taken for pain)
                    </span>
                </p>
                <p>
                    <input type="checkbox" id="cbPainMedicationsNone" name="cbPainMedicationsNone" className='add-only' value="None" /> None

                </p>

                <p><strong>(1)</strong></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Frequency	</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribed by?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicationName_11" name="txtMedicationName_11" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDose_11" name="txtDose_11" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrescribed_11" name="txtPrescribed_11" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-250'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-250'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWhenPrescribed_11" name="txtWhenPrescribed_11" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRefill_11" name="txtRefill_11" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSideEffects_11" name="txtSideEffects_11" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>(2)</strong></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Frequency	</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribed by?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicationName_12" name="txtMedicationName_12" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDose_12" name="txtDose_12" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrescribed_12" name="txtPrescribed_12" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-250'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-250'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWhenPrescribed_12" name="txtWhenPrescribed_12" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRefill_12" name="txtRefill_12" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSideEffects_12" name="txtSideEffects_12" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>(3)</strong></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Frequency	</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribed by?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicationName_13" name="txtMedicationName_13" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDose_13" name="txtDose_13" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrescribed_13" name="txtPrescribed_13" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-250'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-250'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWhenPrescribed_13" name="txtWhenPrescribed_13" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRefill_13" name="txtRefill_13" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSideEffects_13" name="txtSideEffects_13" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>(4)</strong></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Frequency	</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribed by?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicationName_14" name="txtMedicationName_14" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDose_14" name="txtDose_14" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrescribed_14" name="txtPrescribed_14" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-250'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-250'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWhenPrescribed_14" name="txtWhenPrescribed_14" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRefill_14" name="txtRefill_14" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSideEffects_14" name="txtSideEffects_14" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>(5)</strong></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Frequency	</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribed by?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicationName_15" name="txtMedicationName_15" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDose_15" name="txtDose_15" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrescribed_15" name="txtPrescribed_15" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-250'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-250'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWhenPrescribed_15" name="txtWhenPrescribed_15" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRefill_15" name="txtRefill_15" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSideEffects_15" name="txtSideEffects_15" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>(6)</strong></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Frequency	</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribed by?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicationName_16" name="txtMedicationName_16" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDose_16" name="txtDose_16" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrescribed_16" name="txtPrescribed_16" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-250'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-250'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWhenPrescribed_16" name="txtWhenPrescribed_16" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRefill_16" name="txtRefill_16" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSideEffects_16" name="txtSideEffects_16" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>(7)</strong></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Frequency	</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribed by?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicationName_17" name="txtMedicationName_17" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDose_17" name="txtDose_17" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrescribed_17" name="txtPrescribed_17" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-250'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-250'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWhenPrescribed_17" name="txtWhenPrescribed_17" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRefill_17" name="txtRefill_17" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSideEffects_17" name="txtSideEffects_17" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>(8)</strong></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Frequency	</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribed by?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicationName_18" name="txtMedicationName_18" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDose_18" name="txtDose_18" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrescribed_18" name="txtPrescribed_18" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-250'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-250'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWhenPrescribed_18" name="txtWhenPrescribed_18" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRefill_18" name="txtRefill_18" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSideEffects_18" name="txtSideEffects_18" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>(9)</strong></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Frequency	</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribed by?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicationName_19" name="txtMedicationName_19" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDose_19" name="txtDose_19" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrescribed_19" name="txtPrescribed_19" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-250'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-250'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWhenPrescribed_19" name="txtWhenPrescribed_19" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRefill_19" name="txtRefill_19" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSideEffects_19" name="txtSideEffects_19" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p><strong>(10)</strong></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Frequency	</span></td>
                        <td className='w-250'><span className='eleHeader'>Prescribed by?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicationName_20" name="txtMedicationName_20" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDose_20" name="txtDose_20" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPrescribed_20" name="txtPrescribed_20" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>When prescribed?</span></td>
                        <td className='w-250'><span className='eleHeader'>When is next refill?</span></td>
                        <td className='w-250'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtWhenPrescribed_20" name="txtWhenPrescribed_20" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRefill_20" name="txtRefill_20" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSideEffects_20" name="txtSideEffects_20" className='add-only' />
                        </td>
                    </tr>
                </table>


                <p>

                    <span className='eleHeader'>Is Individual compliant with medications?</span>
                    <input type="radio" id="rbIndividualCompliant_Yes" name="rbIndividualCompliant" className='add-only' value="Yes" />  Yes &nbsp;
                    <input type="radio" id="rbIndividualCompliant_No" name="rbIndividualCompliant" className='add-only' value="No" />  No Explain:
                    <textarea id='txtIndividualCompliant_Explain' name='txtIndividualCompliant_Explain' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Current Physician Prescribing Medication(s) for Pain:</span></td>
                        <td className='w-375'><span className='eleHeader'>Telephone No.:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtMedicationPain" name="txtMedicationPain" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtCurrentPhysicianTelephone" name="txtCurrentPhysicianTelephone" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>NUTRITIONAL SCREENING </span>
                    <input type="checkbox" name="chkDeaf" id="chkDeaf" className='add-only' value="Deaf" /> Deaf &nbsp;
                    <input type="checkbox" name="chkBlind" id="chkBlind" className='add-only' value="Blind" /> Blind
                </p>
                <table>
                    <tr>
                        <td className='w-750'><strong>Nutritional Status</strong></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Current Weight:</span></td>
                        <td className='w-375'><span className='eleHeader'>Current Height:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtCurrentWeight" name="txtCurrentWeight" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtCurrentHeight" name="txtCurrentHeight" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Appetite</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbAppetite_1" name="cbAppetite_1" className='add-only' value="Appetite_1" /> Good
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbAppetite_2" name="cbAppetite_2" className='add-only' value="Appetite_2" /> Fair
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbAppetite_3" name="cbAppetite_3" className='add-only' value="Appetite_3" /> Poor,explain below
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtExplainBelowAppetite_3" name="txtExplainBelowAppetite_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Eating Behavior</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbEatingBehavior_1" name="cbEatingBehavior_1" className='add-only' value="EatingBehavior_1" /> Binges/overeats to excess
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbEatingBehavior_2" name="cbEatingBehavior_2" className='add-only' value="EatingBehavior_2" /> Hiding/Hording food
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbEatingBehavior_3" name="cbEatingBehavior_3" className='add-only' value="EatingBehavior_3" /> Restricts food/vomits/over-exercises to avoid weight gain
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Other</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbOther_1" name="cbOther_1" className='add-only' value="Other_1" /> Recently gained/lost significant weight
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbOther_2" name="cbOther_2" className='add-only' value="Other_2" /> Special Dietary Needs
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbOther_3" name="cbOther_3" className='add-only' value="Other_3" /> Allergies, explain below
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtExplainBelowOther_3" name="txtExplainBelowOther_3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>HIV Prevention Education information offered</span>
                    <input type="radio" id="rbHivPreventionAccepted_Yes" name="rbHivPreventionAcceptedDeclined" className='add-only' value="Accepted" />  Accepted &nbsp;
                    <input type="radio" id="rbHivPreventionDeclined_No" name="rbHivPreventionAcceptedDeclined" className='add-only' value="Declined" />  Declined
                </p>
                <p>
                    <span className='eleHeader'>HIV Testing referral offered</span>
                    <input type="radio" id="rbHivTestingAccepted_Yes" name="rbHivTestingAcceptedDeclined" className='add-only' value="Accepted" />  Accepted &nbsp;
                    <input type="radio" id="rbHivTestingDeclined_No" name="rbHivTestingAcceptedDeclined" className='add-only' value="Declined" />  Declined
                </p>
                <p>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtHivComments" name="txtHivComments" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>ASSISTIVE TECHNOLOGY OR ADAPTIVE DEVICES</span>

                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAssistiveTechnology_1" name="cbAssistiveTechnology_1" className='add-only' value="AssistiveTechnology_1" /> None
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAssistiveTechnology_2" name="cbAssistiveTechnology_2" className='add-only' value="AssistiveTechnology_2" /> Glasses
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAssistiveTechnology_3" name="cbAssistiveTechnology_3" className='add-only' value="AssistiveTechnology_3" /> Walker
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAssistiveTechnology_4" name="cbAssistiveTechnology_4" className='add-only' value="AssistiveTechnology_4" /> Braille
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAssistiveTechnology_5" name="cbAssistiveTechnology_5" className='add-only' value="AssistiveTechnology_5" /> Hearing Aids
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAssistiveTechnology_6" name="cbAssistiveTechnology_6" className='add-only' value="AssistiveTechnology_6" /> Cane
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAssistiveTechnology_7" name="cbAssistiveTechnology_7" className='add-only' value="AssistiveTechnology_7" /> Crutches
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAssistiveTechnology_8" name="cbAssistiveTechnology_8" className='add-only' value="AssistiveTechnology_8" /> Wheelchair
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAssistiveTechnology_9" name="cbAssistiveTechnology_9" className='add-only' value="AssistiveTechnology_9" /> Translated Written Information
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAssistiveTechnology_10" name="cbAssistiveTechnology_10" className='add-only' value="AssistiveTechnology_10" /> Translator for Speaking
                        </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbAssistiveTechnology_11" name="cbAssistiveTechnology_11" className='add-only' value="AssistiveTechnology_11" /> Other :
                            <input type="text" id="txtAssistiveTechnology_11" name="txtAssistiveTechnology_11" className='add-only' />
                        </td>

                    </tr>
                </table>
                <p>
                    If any of the above were checked, please provide details below. (list allergies)
                    <textarea id="txtAssistiveTechnology" name="txtAssistiveTechnology" className='add-only'></textarea>
                </p>

                <h3>H.	FAMILY MEDICAL HISTORY</h3>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Type of Illness</span></td>
                        <td className='w-70'><span className='eleHeader'>Yes</span></td>
                        <td className='w-70'><span className='eleHeader'>No</span></td>
                        <td className='w-410'><span className='eleHeader'>Relationship (Father, Mother, Sibling, Aunt, Uncle, etc... .)</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Cardiovascular</td>
                        <td className='w-70'>
                            <input type="radio" id="rbIllnessYes_1" name="rbIllness_1" className='add-only' value="IllnessYes_1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbIllnessNo_1" name="rbIllness_1" className='add-only' value="IllnessNo_1" />
                        </td>
                        <td className='w-410'>
                            <input type="text" id="txtRelationship_1" name="txtRelationship_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Hypertension</td>
                        <td className='w-70'>
                            <input type="radio" id="rbIllnessYes_2" name="rbIllness_2" className='add-only' value="IllnessYes_2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbIllnessNo_2" name="rbIllness_2" className='add-only' value="IllnessNo_2" />
                        </td>
                        <td className='w-410'>
                            <input type="text" id="txtRelationship_2" name="txtRelationship_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Seizures</td>
                        <td className='w-70'>
                            <input type="radio" id="rbIllnessYes_3" name="rbIllness_3" className='add-only' value="IllnessYes_3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbIllnessNo_3" name="rbIllness_3" className='add-only' value="IllnessNo_3" />
                        </td>
                        <td className='w-410'>
                            <input type="text" id="txtRelationship_3" name="txtRelationship_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Psychiatric Hospitalization</td>
                        <td className='w-70'>
                            <input type="radio" id="rbIllnessYes_4" name="rbIllness_4" className='add-only' value="IllnessYes_4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbIllnessNo_4" name="rbIllness_4" className='add-only' value="IllnessNo_4" />
                        </td>
                        <td className='w-410'>
                            <input type="text" id="txtRelationship_4" name="txtRelationship_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Suicide</td>
                        <td className='w-70'>
                            <input type="radio" id="rbIllnessYes_5" name="rbIllness_5" className='add-only' value="IllnessYes_5" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbIllnessNo_5" name="rbIllness_5" className='add-only' value="IllnessNo_5" />
                        </td>
                        <td className='w-410'>
                            <input type="text" id="txtRelationship_5" name="txtRelationship_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Depression</td>
                        <td className='w-70'>
                            <input type="radio" id="rbIllnessYes_6" name="rbIllness_6" className='add-only' value="IllnessYes_6" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbIllnessNo_6" name="rbIllness_6" className='add-only' value="IllnessNo_6" />
                        </td>
                        <td className='w-410'>
                            <input type="text" id="txtRelationship_6" name="txtRelationship_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Addictions</td>
                        <td className='w-70'>
                            <input type="radio" id="rbIllnessYes_7" name="rbIllness_7" className='add-only' value="IllnessYes_7" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbIllnessNo_7" name="rbIllness_7" className='add-only' value="IllnessNo_7" />
                        </td>
                        <td className='w-410'>
                            <input type="text" id="txtRelationship_7" name="txtRelationship_7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Eating Disorder</td>
                        <td className='w-70'>
                            <input type="radio" id="rbIllnessYes_8" name="rbIllness_8" className='add-only' value="IllnessYes_8" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbIllnessNo_8" name="rbIllness_8" className='add-only' value="IllnessNo_8" />
                        </td>
                        <td className='w-410'>
                            <input type="text" id="txtRelationship_8" name="txtRelationship_8" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Cancer</td>
                        <td className='w-70'>
                            <input type="radio" id="rbIllnessYes_9" name="rbIllness_9" className='add-only' value="IllnessYes_9" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbIllnessNo_9" name="rbIllness_9" className='add-only' value="IllnessNo_9" />
                        </td>
                        <td className='w-410'>
                            <input type="text" id="txtRelationship_9" name="txtRelationship_9" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Other:</td>
                        <td className='w-70'>
                            <input type="radio" id="rbIllnessYes_10" name="rbIllness_10" className='add-only' value="IllnessYes_10" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbIllnessNo_10" name="rbIllness_10" className='add-only' value="IllnessNo_10" />
                        </td>
                        <td className='w-410'>
                            <input type="text" id="txtRelationship_10" name="txtRelationship_10" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>I.	BEHAVIOR AND MENTAL HEALTH ASSESSMENT</h3>
                <p>
                    Please complete the below checklist for symptoms:
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Key:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><strong>Severity Rating:</strong></td>
                        <td className='w-375'><strong>Duration Rating:</strong></td>
                    </tr>
                    <tr>
                        <td className='w-50'><strong>1</strong></td>
                        <td className='w-325'>Mild</td>
                        <td className='w-50'><strong>1</strong></td>
                        <td className='w-325'>Less than 1 Month</td>
                    </tr>
                    <tr>
                        <td className='w-50'><strong>2</strong></td>
                        <td className='w-325'>Moderate</td>
                        <td className='w-50'><strong>2</strong></td>
                        <td className='w-325'>1 to 6 Months</td>
                    </tr>
                    <tr>
                        <td className='w-50'><strong>3</strong></td>
                        <td className='w-325'>Severe</td>
                        <td className='w-50'><strong>3</strong></td>
                        <td className='w-325'>7 to 11 Months</td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-325'>&nbsp;</td>
                        <td className='w-50'><strong>4</strong></td>
                        <td className='w-325'>More than 1 Year</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-450'><span className='eleHeader'>Symptom/Problem</span></td>
                        <td className='w-150'><span className='eleHeader'>Severity</span></td>
                        <td className='w-150'><span className='eleHeader'>Duration</span></td>
                    </tr>
                    <tr>
                        <td className='w-450'>1.	Anxiety</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_1" name="txtSeverity_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_1" name="txtDuration_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>2.	Appetite Problems</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_2" name="txtSeverity_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_2" name="txtDuration_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>3.	Bizarre Behavior</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_3" name="txtSeverity_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_3" name="txtDuration_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>4.	Bizarre Ideations (Delusions)</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_4" name="txtSeverity_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_4" name="txtDuration_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>5.	Conduct Problems</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_5" name="txtSeverity_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_5" name="txtDuration_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>6.	Depression</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_6" name="txtSeverity_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_6" name="txtDuration_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>7.	Eating Disorder</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_7" name="txtSeverity_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_7" name="txtDuration_7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>8.	Family Problems</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_8" name="txtSeverity_8" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_8" name="txtDuration_8" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>9.	Gender Issues</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_9" name="txtSeverity_9" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_9" name="txtDuration_9" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>10.	Impaired Memory</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_10" name="txtSeverity_10" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_10" name="txtDuration_10" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>11.	Indep. Living Problems</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_11" name="txtSeverity_11" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_11" name="txtDuration_11" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>12.	Lack of Support System</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_12" name="txtSeverity_12" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_12" name="txtDuration_12" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>13.	Loss of Energy</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_13" name="txtSeverity_13" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_13" name="txtDuration_13" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>14.	Loss of Interest</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_14" name="txtSeverity_14" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_14" name="txtDuration_14" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>15.	Obsessive/Compulsive</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_15" name="txtSeverity_15" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_15" name="txtDuration_15" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>16.	Panic Attacks</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_16" name="txtSeverity_16" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_16" name="txtDuration_16" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>17.	Paranoid Ideation</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_17" name="txtSeverity_17" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_17" name="txtDuration_17" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>18.	Phobia</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_18" name="txtSeverity_18" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_18" name="txtDuration_18" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>19.	Poor Interpersonal Skills</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_19" name="txtSeverity_19" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_19" name="txtDuration_19" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>20.	Poor Judgment</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_20" name="txtSeverity_20" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_20" name="txtDuration_20" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>21. Poor Self Care Skills</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_21" name="txtSeverity_21" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_21" name="txtDuration_21" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>22. School Problems</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_22" name="txtSeverity_22" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_22" name="txtDuration_22" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>23. Sexual Acting Out</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_23" name="txtSeverity_23" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_23" name="txtDuration_23" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>24. Sleep Problems</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_24" name="txtSeverity_24" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_24" name="txtDuration_24" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>25. Somatization</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_25" name="txtSeverity_25" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_25" name="txtDuration_25" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>26. Unusual Body Movements</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_26" name="txtSeverity_26" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_26" name="txtDuration_26" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>27. Other</td>
                        <td className='w-150'>
                            <input type="text" id="txtSeverity_27" name="txtSeverity_27" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDuration_27" name="txtDuration_27" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    If any of the above were checked, please provide specific details below. Please indicate frequency and intensity of symptoms.
                    <textarea id="txtSymptomProblemDetail" name="txtSymptomProblemDetail" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Has Individual ever been treated for a mental health problem?</span>
                    <span className='small'>(Include specific diagnosis, when problem was diagnosed, interventions, and outcome)</span>
                </p>

                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Date (s)</span></td>
                        <td className='w-150'><span className='eleHeader'>Location</span></td>
                        <td className='w-150'><span className='eleHeader'>Type of Treatment (Outpatient, Inpatient, etc)</span></td>
                        <td className='w-150'><span className='eleHeader'>Diagnosis Given</span></td>
                        <td className='w-150'><span className='eleHeader'>Outcome (i.e., stabilized, withdrew from services, etc.)</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="date" id="txtDate_1" name="txtDate_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtLocation_1" name="txtLocation_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtTreatment_1" name="txtTreatment_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDiagnosis_1" name="txtDiagnosis_" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtOutcome_1" name="txtOutcome_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="date" id="txtDate_2" name="txtDate_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtLocation_2" name="txtLocation_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtTreatment_2" name="txtTreatment_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDiagnosis_2" name="txtDiagnosis_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtOutcome_2" name="txtOutcome_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="date" id="txtDate_3" name="txtDate_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtLocation_3" name="txtLocation_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtTreatment_3" name="txtTreatment_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDiagnosis_3" name="txtDiagnosis_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtOutcome_3" name="txtOutcome_3" className='add-only' />
                        </td>
                    </tr>
                </table>

                <h3>J.	COLUMBIA-SUICIDE SEVERITY RATING SCALE</h3>
                <h4>COLUMBIA-SUICIDE SEVERITY RATING SCALE
                    <br />
                    Screen Version
                </h4>
                <p>
                    *For Initial BHA (answer as LIFETIME) ONLY
                    <br />
                    *For Reassessment (answer as Recent/Last 30 days) ONLY
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>SUICIDE IDEATION DEFINITIONS AND PROMPTS:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>

                            <input type='checkbox' id='cbReAxPastMonth' name='cbReAxPastMonth' className='add-only' value='ReAxPastMonth' />Re-Ax- Past Month &nbsp;
                            <input type='checkbox' id='cbInitialLifetime' name='cbInitialLifetime' className='add-only' value='InitialLifetime' /> INITIAL - LIFETIME
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'><strong>Ask questions that are bolded and underlined.</strong></td>
                        <td className='w-50'><strong>Yes</strong></td>
                        <td className='w-50'><strong>No</strong></td>
                    </tr>
                    <tr>
                        <td className='w-750'><strong>Ask Questions 1 and 2 </strong></td>
                    </tr>
                    <tr>
                        <td className='w-750'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>(1) Wish to be Dead: </strong>
                            <br />
                            Person endorses thoughts about a wish to be dead or not alive anymore, or wish to fall asleep and not wake up.<br />
                            <strong>Have you wished you were dead or wished you could go to sleep and not wake up? </strong>
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbAskQuestionsYes_1" name="rbAskQuestions_1" className='add-only' value="Yes" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbAskQuestionsNo_1" name="rbAskQuestions_1" className='add-only' value="No" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>(2) Suicidal Thoughts:</strong><br />
                            General non-specific thoughts of wanting to end one's life/commit suicide, "I've thought about killing myself" without general thoughts of ways to kill oneself/associated methods, intent, or plan."
                            <br />
                            <strong>Have you actually had any thoughts of killing yourself? </strong>

                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbAskQuestionsYes_2" name="rbAskQuestions_2" className='add-only' value="Yes" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbAskQuestionsNo_2" name="rbAskQuestions_2" className='add-only' value="No" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'><strong>If YES to 2, ask questions 3, 4, 5, and 6.  If NO to 2, go directly to question 6.</strong> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>(3) Suicidal Thoughts with Method (without Specific Plan or Intent to Act): </strong>
                            <br />
                            Person endorses thoughts of suicide and has thought of a least one method during the assessment period. This is different than a specific plan with time, place or method details worked out. "I thought about taking an overdose but I never made a specific plan as to when where or how I would actually do it... .and I would never go through with it."
                            <br />
                            <strong>Have you been thinking about how you might kill yourself?  </strong>
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbAskQuestionsYes_3" name="rbAskQuestions_3" className='add-only' value="Yes" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbAskQuestionsNo_3" name="rbAskQuestions_3" className='add-only' value="No" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>(4) Suicidal Intent (without Specific Plan):  </strong>
                            <br />
                            Active suicidal thoughts of killing oneself and patient reports having some intent to act on such thoughts, as opposed to "I have the thoughts but I definitely will not do anything about them."
                            <br />
                            <strong>Have you had these thoughts and had some intention of acting on them?</strong>
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbAskQuestionsYes_4" name="rbAskQuestions_4" className='add-only' value="Yes" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbAskQuestionsNo_4" name="rbAskQuestions_4" className='add-only' value="No" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>(5) Suicide Intent with Specific Plan: </strong>
                            <br />
                            Thoughts of killing oneself with details of plan fully or partially worked out and person has some intent to carry it out.
                            <br />
                            <strong>Have you started to work out or worked out the details of how to kill yourself? Do you intend to carry out this plan?  </strong>
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbAskQuestionsYes_5" name="rbAskQuestions_5" className='add-only' value="Yes" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbAskQuestionsNo_5" name="rbAskQuestions_5" className='add-only' value="No" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            <strong>(6) Suicide Behavior Question </strong>
                            <br />
                            <strong>"Have you ever done anything, started to do anything, or prepared to do anything to end your life?" </strong>
                            <br />
                            Examples: Collected pills, obtained a gun, gave away valuables, wrote a will or suicide note, took out pills but didn't swallow any, held a gun but changed your mind or it was grabbed from your hand, went to the roof but didn't jump; or actually took pills, tried to shoot yourself, cut yourself, tried to hang yourself, etc.

                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbAskQuestionsYes_6" name="rbAskQuestions_6" className='add-only' value="Yes" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbAskQuestionsNo_6" name="rbAskQuestions_6" className='add-only' value="No" />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>If YES, ask: How long ago did you do any of these?</span>

                    <input type="radio" id="rbHowLong_OverYear" name="rbHowLong" className='add-only' value="OverYear" />
                    Over a year ago?
                    <input type="radio" id="rbHowLong_ThreeMonthsYear" name="rbHowLong" className='add-only' value="ThreeMonths_Year" />
                    Between three months and a year ago?
                    <input type="radio" id="rbHowLong_ThreeMonths" name="rbHowLong" className='add-only' value="ThreeMonths" />
                    Within the last three months?
                    <input type="radio" id="rbHowLong_Na" name="rbHowLong" className='add-only' value="ThreeMonths" />
                    N/A
                </p>

                <h3>K. SUBSTANCE ABUSE HISTORY</h3>
                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Substance Name</span></td>
                        <td className='w-150'><span className='eleHeader'>Age of 1st Use</span></td>
                        <td className='w-150'><span className='eleHeader'>Age of Heaviest Use</span></td>
                        <td className='w-150'><span className='eleHeader'>Frequency/Amount</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of Last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Alcohol</td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_1" name="txtAgeFirstUse_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_1" name="txtAgeHeaviestUse_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_1" name="txtAmount_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_1" name="txtLastuse_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Cannabis</td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_2" name="txtAgeFirstUse_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_2" name="txtAgeHeaviestUse_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_2" name="txtAmount_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_2" name="txtLastuse_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Cocaine</td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_3" name="txtAgeFirstUse_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_3" name="txtAgeHeaviestUse_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_3" name="txtAmount_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_3" name="txtLastuse_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Stimulants
                            <span className='small'>(Crystal, speed, amphetamines)</span>

                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_4" name="txtAgeFirstUse_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_4" name="txtAgeHeaviestUse_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_4" name="txtAmount_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_4" name="txtLastuse_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Methamphetamine</td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_5" name="txtAgeFirstUse_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_5" name="txtAgeHeaviestUse_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_5" name="txtAmount_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_5" name="txtLastuse_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Inhalants
                            <span className='small'>(LSD, PCP, mushrooms)</span>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_6" name="txtAgeFirstUse_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_6" name="txtAgeHeaviestUse_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_6" name="txtAmount_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_6" name="txtLastuse_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Opioids
                            <span className='small'>(Heroine, Narcotics, Methadone)</span>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_7" name="txtAgeFirstUse_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_7" name="txtAgeHeaviestUse_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_7" name="txtAmount_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_7" name="txtLastuse_7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Sedative/Hypnotics
                            <span className='small'>(Valium,  Xanax)</span>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_8" name="txtAgeFirstUse_8" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_8" name="txtAgeHeaviestUse_8" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_8" name="txtAmount_8" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_8" name="txtLastuse_8" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Designer Drugs
                            <span className='small'>(Herbal, Steroids, Cough Syrup)</span>
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_9" name="txtAgeFirstUse_9" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_9" name="txtAgeHeaviestUse_9" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_9" name="txtAmount_9" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_9" name="txtLastuse_9" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Tobacco</td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_10" name="txtAgeFirstUse_10" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_10" name="txtAgeHeaviestUse_10" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_10" name="txtAmount_10" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_10" name="txtLastuse_10" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Other</td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeFirstUse_11" name="txtAgeFirstUse_11" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAgeHeaviestUse_11" name="txtAgeHeaviestUse_11" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtAmount_11" name="txtAmount_11" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtLastuse_11" name="txtLastuse_11" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>What consequences has the Individual faced as a result of the Drug/Alcohol use?</span>
                    <span className='small'>(Include hangovers, DT's, Blackouts, Binges, Overdoses, Seizures, GI Bleeding, Job Loss, DUI's, Assaults, Incarcerations, Homicides, etc)</span>

                    <textarea id="txtConsequences" name="txtConsequences" className='add-only'></textarea>

                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Longest period of sobriety?</span></td>
                        <td className='w-375'><span className='eleHeader'>When?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtLongestSobriety" name="txtLongestSobriety" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtLongestSobrietyWhen" name="txtLongestSobrietyWhen" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>L. LEGAL HISTORY </h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_1" name="cbLegalHistory_1" className='add-only' value="LegalHistory_1" />
                            Probation Officer Contact and County:

                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_2" name="cbLegalHistory_2" className='add-only' value="LegalHistory_2" />
                            Parole  Officer Contact and County:

                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtLegalHistory_1" name="txtLegalHistory_1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtLegalHistory_2" name="txtLegalHistory_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_3" name="cbLegalHistory_3" className='add-only' value="LegalHistory_3" />
                            Number of Arrest in Past 30 Days:

                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_4" name="cbLegalHistory_4" className='add-only' value="LegalHistory_4" />
                            Number of arrests in the past year:

                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtLegalHistory_3" name="txtLegalHistory_3" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtLegalHistory_4" name="txtLegalHistory_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_5" name="cbLegalHistory_5" className='add-only' value="LegalHistory_5" />
                            Current Pending Charges:
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_6" name="cbLegalHistory_6" className='add-only' value="LegalHistory_6" />
                            DFCS/CPS and County
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtLegalHistory_5" name="txtLegalHistory_5" className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_7" name="cbLegalHistory_7" className='add-only' value="LegalHistory_7" />
                            Restraining Order
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLegalHistory_8" name="cbLegalHistory_8" className='add-only' value="LegalHistory_8" />
                            None
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>&nbsp;</td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>
                <h3>M.	FAMILY HISTORY</h3>
                <p>
                    <strong>HOUSEHOLD COMPOSITION AT TIME OF ASSESSMENT</strong>
                </p>



                <table>
                    <tr>
                        <td className='w-300'><span className='eleHeader'>Name</span></td>
                        <td className='w-150'><span className='eleHeader'>Relationship to Individual</span></td>
                        <td className='w-200'><span className='eleHeader'>Date of Birth</span></td>
                        <td className='w-100'><span className='eleHeader'>Age</span></td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type="text" id="txtName_1" name="txtName_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtRelationshipIndividual_1" name="txtRelationshipIndividual_1" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="date" id="txtDob_1" name="txtDob_1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAge_1" name="txtAge_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type="text" id="txtName_2" name="txtName_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtRelationshipIndividual_2" name="txtRelationshipIndividual_2" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="date" id="txtDob_2" name="txtDob_2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAge_2" name="txtAge_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type="text" id="txtName_3" name="txtName_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtRelationshipIndividual_3" name="txtRelationshipIndividual_3" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="date" id="txtDob_3" name="txtDob_3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAge_3" name="txtAge_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type="text" id="txtName_4" name="txtName_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtRelationshipIndividual_4" name="txtRelationshipIndividual_4" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="date" id="txtDob_4" name="txtDob_4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAge_4" name="txtAge_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type="text" id="txtName_5" name="txtName_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtRelationshipIndividual_5" name="txtRelationshipIndividual_5" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="date" id="txtDob_5" name="txtDob_5" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAge_5" name="txtAge_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type="text" id="txtName_6" name="txtName_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtRelationshipIndividual_6" name="txtRelationshipIndividual_6" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="date" id="txtDob_6" name="txtDob_6" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAge_6" name="txtAge_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type="text" id="txtName_7" name="txtName_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtRelationshipIndividual_7" name="txtRelationshipIndividual_7" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="date" id="txtDob_7" name="txtDob_7" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAge_7" name="txtAge_7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type="text" id="txtName_8" name="txtName_8" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtRelationshipIndividual_8" name="txtRelationshipIndividual_8" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="date" id="txtDob_8" name="txtDob_8" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAge_8" name="txtAge_8" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type="text" id="txtName_9" name="txtName_9" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtRelationshipIndividual_9" name="txtRelationshipIndividual_9" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="date" id="txtDob_9" name="txtDob_9" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAge_9" name="txtAge_9" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type="text" id="txtName_10" name="txtName_10" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtRelationshipIndividual_10" name="txtRelationshipIndividual_10" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="date" id="txtDob_10" name="txtDob_10" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAge_10" name="txtAge_10" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>LIVING SITUATION </span>
                    <span className='small'>(Check all that apply)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_1" name="cbLivingSituation_1" className='add-only' value="LivingSituation_1" />
                            Home w/ family of origin
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_2" name="cbLivingSituation_2" className='add-only' value="LivingSituation_2" />
                            Independent Living
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_3" name="cbLivingSituation_3" className='add-only' value="LivingSituation_3" />
                            Group Home/Foster Home
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_4" name="cbLivingSituation_4" className='add-only' value="LivingSituation_4" />
                            Homeless
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_5" name="cbLivingSituation_5" className='add-only' value="LivingSituation_5" />
                            Adequate Housing
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_6" name="cbLivingSituation_6" className='add-only' value="LivingSituation_6" />
                            Safety Risks/Hazardous
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_7" name="cbLivingSituation_7" className='add-only' value="LivingSituation_7" />
                            Overcrowded
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLivingSituation_8" name="cbLivingSituation_8" className='add-only' value="LivingSituation_8" />
                            Risk of Homelessness
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>What is the family's source(s) of income? Is income monthly, bi-weekly? Is income sufficient for household expenses?</span>
                    <textarea id="txtFamilySourceIncome" name="txtFamilySourceIncome" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Describe Individual's relationship with biological parents.</span>
                    <textarea id="txtDescribeIndividualRelationship" name="txtDescribeIndividualRelationship" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Describe Individual's relationship with siblings.  How would you describe yourself as a child growing up in your family? </span>
                    <span className='small'>(popular, aggressive, awkward, etc... ..)</span>
                    <textarea id="txtDescribeIndividualRelationshipSiblings" name="txtDescribeIndividualRelationshipSiblings" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Did you experience problems during your childhood? </span>
                    <span className='small'>(conflict with parents, siblings, teachers, overweight, etc... ..)</span>
                    <textarea id="txtExperienceProblems" name="txtExperienceProblems" className='add-only'></textarea>
                </p>
                <p>
                    <strong>SEXUALITY</strong>
                </p>
                <p>
                    <span className='eleHeader'>Do you consider yourself a member of the Lesbian, Gay, Bisexual and/or Transgender (LGBT) community?</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbMemberGender_Yes" name="rbMemberGender" className='add-only' value="Yes" />  Yes
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbMemberGender_No" name="rbMemberGender" className='add-only' value="No" />  No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbMemberGender_NoAlly" name="rbMemberGender" className='add-only' value="NoAlly" />  No, but I identify as an Ally
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbMemberGender_PreferNot" name="rbMemberGender" className='add-only' value="PreferNotSay" />  Prefer not to say
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>What is your Sexual Orientation?</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbSexualOrientation_StraightHeterosexual" name="rbSexualOrientation" className='add-only' value="StraightHeterosexual" /> Straight/Heterosexual
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbSexualOrientation_Gay" name="rbSexualOrientation" className='add-only' value="Gay" /> Gay or Lesbian
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbSexualOrientation_Bisexual" name="rbSexualOrientation" className='add-only' value="Bisexual" /> Bisexual
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbSexualOrientation_PreferNot" name="rbSexualOrientation" className='add-only' value="PreferNot" /> Prefer not to say
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbSexualOrientation_PreferSelf" name="rbSexualOrientation" className='add-only' value="PreferSelf" /> Prefer to self-describe

                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtSexualOrientation_PreferSelf" name="txtSexualOrientation_PreferSelf" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>MARITAL HISTORY</strong>
                </p>
                <p>
                    <span className='eleHeader'>Marital Status:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMaritalStatus_1" name="cbMaritalStatus_1" className='add-only' value="MaritalStatus_1" /> Married
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMaritalStatus_2" name="cbMaritalStatus_2" className='add-only' value="MaritalStatus_2" /> Single
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMaritalStatus_3" name="cbMaritalStatus_3" className='add-only' value="MaritalStatus_3" /> Co-Habitation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMaritalStatus_4" name="cbMaritalStatus_4" className='add-only' value="MaritalStatus_4" /> Divorced
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMaritalStatus_5" name="cbMaritalStatus_5" className='add-only' value="MaritalStatus_5" /> Separated
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMaritalStatus_6" name="cbMaritalStatus_6" className='add-only' value="MaritalStatus_6" /> Widowed
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Number of Previous Marriages:</span></td>
                        <td className='w-375'><span className='eleHeader'>Length of Time with current partner:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtNumberPreviousMarriages" name="txtNumberPreviousMarriages" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtLengthTimeCurrentPartner" name="txtLengthTimeCurrentPartner" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>How would you describe your relationship with your current partner?</span>
                    <textarea id="txtDescribeRelationship" name="txtDescribeRelationship" className='add-only'></textarea>
                </p>
                <p>
                    <strong>TRAUMA & ABUSE HISTORY</strong>
                </p>
                <p>
                    <span className='eleHeader'>Physical Abuse</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalAbuse_1" name="cbPhysicalAbuse_1" className='add-only' value="PhysicalAbuse_1" /> Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalAbuse_2" name="cbPhysicalAbuse_2" className='add-only' value="PhysicalAbuse_2" /> Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalAbuse_3" name="cbPhysicalAbuse_3" className='add-only' value="PhysicalAbuse_3" /> Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalAbuse_4" name="cbPhysicalAbuse_4" className='add-only' value="PhysicalAbuse_4" /> Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalAbuse_5" name="cbPhysicalAbuse_5" className='add-only' value="PhysicalAbuse_5" /> Current
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Domestic Violence</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDomesticViolence_1" name="cbDomesticViolence_1" className='add-only' value="DomesticViolence_1" /> Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDomesticViolence_2" name="cbDomesticViolence_2" className='add-only' value="DomesticViolence_2" /> Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDomesticViolence_3" name="cbDomesticViolence_3" className='add-only' value="DomesticViolence_3" /> Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDomesticViolence_4" name="cbDomesticViolence_4" className='add-only' value="DomesticViolence_4" /> Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDomesticViolence_5" name="cbDomesticViolence_5" className='add-only' value="DomesticViolence_5" /> Current
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Community Violence</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCommunityViolence_1" name="cbCommunityViolence_1" className='add-only' value="CommunityViolence_1" /> Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCommunityViolence_2" name="cbCommunityViolence_2" className='add-only' value="CommunityViolence_2" /> Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCommunityViolence_3" name="cbCommunityViolence_3" className='add-only' value="CommunityViolence_3" /> Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCommunityViolence_4" name="cbCommunityViolence_4" className='add-only' value="CommunityViolence_4" /> Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCommunityViolence_5" name="cbCommunityViolence_5" className='add-only' value="CommunityViolence_5" /> Current
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Physical Neglect</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalNeglect_1" name="cbPhysicalNeglect_1" className='add-only' value="PhysicalNeglect_1" /> Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalNeglect_2" name="cbPhysicalNeglect_2" className='add-only' value="PhysicalNeglect_2" /> Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalNeglect_3" name="cbPhysicalNeglect_3" className='add-only' value="PhysicalNeglect_3" /> Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalNeglect_4" name="cbPhysicalNeglect_4" className='add-only' value="PhysicalNeglect_4" /> Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPhysicalNeglect_5" name="cbPhysicalNeglect_5" className='add-only' value="PhysicalNeglect_5" /> Current
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Emotional Abuse</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEmotionalAbuse_1" name="cbEmotionalAbuse_1" className='add-only' value="EmotionalAbuse_1" /> Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEmotionalAbuse_2" name="cbEmotionalAbuse_2" className='add-only' value="EmotionalAbuse_2" /> Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEmotionalAbuse_3" name="cbEmotionalAbuse_3" className='add-only' value="EmotionalAbuse_3" /> Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEmotionalAbuse_4" name="cbEmotionalAbuse_4" className='add-only' value="EmotionalAbuse_4" /> Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEmotionalAbuse_5" name="cbEmotionalAbuse_5" className='add-only' value="EmotionalAbuse_5" /> Current
                        </td>

                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Elder Abuse</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbElderAbuse_1" name="cbElderAbuse_1" className='add-only' value="ElderAbuse_1" /> Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbElderAbuse_2" name="cbElderAbuse_2" className='add-only' value="ElderAbuse_2" /> Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbElderAbuse_3" name="cbElderAbuse_3" className='add-only' value="ElderAbuse_3" /> Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbElderAbuse_4" name="cbElderAbuse_4" className='add-only' value="ElderAbuse_4" /> Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbElderAbuse_5" name="cbElderAbuse_5" className='add-only' value="ElderAbuse_5" /> Current
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Sexual Abuse</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexualAbuse_1" name="cbSexualAbuse_1" className='add-only' value="SexualAbuse_1" /> Victim
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexualAbuse_2" name="cbSexualAbuse_2" className='add-only' value="SexualAbuse_2" /> Perpetrator
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexualAbuse_3" name="cbSexualAbuse_3" className='add-only' value="SexualAbuse_3" /> Direct Exposure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexualAbuse_4" name="cbSexualAbuse_4" className='add-only' value="SexualAbuse_4" /> Indirect Exposure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexualAbuse_5" name="cbSexualAbuse_5" className='add-only' value="SexualAbuse_5" /> Current
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>No Abuse History</span>
                    <input type="checkbox" id="cbNoAbuseHistory" name="cbNoAbuseHistory" className='add-only' value="NoAbuseHistory" />
                </p>
                <p>
                    <span className='eleHeader'>Is there a history of violence in past or current relationships?</span>
                    <span className='small'>Please provide details of Abuse History (if applicable):</span>
                    <textarea id="txtHistoryViolence" name="txtHistoryViolence" className='add-only'></textarea>
                </p>
                <h3>N.	EDUCATION ASSESSMENT</h3>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Last School Attended:</span></td>
                        <td className='w-250'><span className='eleHeader'>Highest Grade Completed:</span></td>
                        <td className='w-250'><span className='eleHeader'>Special Education:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtLastSchoolAttended" name="txtLastSchoolAttended" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtHighestGrade" name="txtHighestGrade" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbSpecialEducation_Yes" name="rbSpecialEducation" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbSpecialEducation_No" name="rbSpecialEducation" className='add-only' value="No" /> No
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>How would you rate your performance in school?
                        <span className='small'>(did you experience any problems in school, etc fighting)</span>

                    </span>
                    <textarea id="txtRatePerformance" name="txtRatePerformance" className='add-only'></textarea>
                </p>
                <h3>O.	OCCUPATION</h3>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Current Employment:</span></td>
                        <td className='w-375'><span className='eleHeader'>How Long:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtCurrentEmployment" name="txtCurrentEmployment" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtHowLong" name="txtHowLong" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Have you experienced problems finding employment?
                        <span className='small'>(please explain):</span>

                    </span>
                    <textarea id="txtHaveExperiencedProblems" name="txtHaveExperiencedProblems" className='add-only'></textarea>
                </p>
                <h3>P.	MILITARY HISTORY</h3>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Have you ever served?</span></td>
                        <td className='w-375'><span className='eleHeader'>If yes what branch?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtServed" name="txtServed" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtBranch" name="txtBranch" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Years in service</span></td>
                        <td className='w-375'><span className='eleHeader'>Discharge Type</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtServiceYears" name="txtServiceYears" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtDischargeType" name="txtDischargeType" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Where you in combat (do you experience any flashbacks, uncontrolled anger outbursts, etc... ..) </span>
                    <textarea id="txtCombat" name="txtCombat" className='add-only'></textarea>
                </p>
                <h3>Q.	ETHNIC/CULTURAL ORIENTATION <span className='small'>(Check all that apply)</span></h3>
                <p>
                    <span className='eleHeader'>What type of community were you raised in:</span>

                    <input type="radio" id="rb_LargeCity" name="rbCommmunity" className='add-only' value="LargeCity" /> Large City &nbsp;
                    <input type="radio" id="rb_MediumSizeCity" name="rbCommmunity" className='add-only' value="MediumSizeCity" /> Medium Size city &nbsp;
                    <input type="radio" id="rb_LargeTown" name="rbCommmunity" className='add-only' value="LargeTown" /> Large Town &nbsp;
                    <input type="radio" id="rb_SmallTown" name="rbCommmunity" className='add-only' value="SmallTown" /> Small Town &nbsp;
                    <input type="radio" id="rb_Rural" name="rbCommmunity" className='add-only' value="Rural" /> Rural
                </p>
                <p>
                    <span className='eleHeader'>What cultural practices linked to your racial/ethnic background is important to you?</span>
                    <textarea id="txtCulturalPractices" name="txtCulturalPractices" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What are your hobbies or leisure preferences</span>
                    <textarea id="txtHobbies" name="txtHobbies" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What are your spiritual preferences:</span>
                    <textarea id="txtSpiritualPreferences" name="txtSpiritualPreferences" className='add-only'></textarea>
                </p>

                <h3>R.	SOCIAL SERVICES/SUPPORT NEEDS <span className='small'>(Check all that apply)</span></h3>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_1" name="cbSocialServices_1" className='add-only' value="SocialServices_1" /> Income maintenance
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_2" name="cbSocialServices_2" className='add-only' value="SocialServices_2" /> Food
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_3" name="cbSocialServices_3" className='add-only' value="SocialServices_3" /> Clothing
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_4" name="cbSocialServices_4" className='add-only' value="SocialServices_4" /> Housing
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_5" name="cbSocialServices_5" className='add-only' value="SocialServices_5" /> Medical
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_6" name="cbSocialServices_6" className='add-only' value="SocialServices_6" /> Education
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_7" name="cbSocialServices_7" className='add-only' value="SocialServices_7" /> Vocational
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_8" name="cbSocialServices_8" className='add-only' value="SocialServices_8" /> Leisure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_9" name="cbSocialServices_9" className='add-only' value="SocialServices_9" /> Social
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSocialServices_10" name="cbSocialServices_10" className='add-only' value="SocialServices_10" />  Other:
                            <input type="text" id="txtSocialServices_Other" name="txtSocialServices_Other" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>S.	FACTORS THAT MAY AFFECT LEARNING/TREATMENT <span className='small'>(Check all that apply)</span></h3>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_1" name="cbFactorsLearning_1" className='add-only' value="FactorsLearning_1" /> None
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_2" name="cbFactorsLearning_2" className='add-only' value="FactorsLearning_2" /> Cognitive Impairment
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_3" name="cbFactorsLearning_3" className='add-only' value="FactorsLearning_3" /> Lack of Motivation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_4" name="cbFactorsLearning_4" className='add-only' value="FactorsLearning_4" /> Abuse/Neglect
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_5" name="cbFactorsLearning_5" className='add-only' value="FactorsLearning_5" /> Pain
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_6" name="cbFactorsLearning_6" className='add-only' value="FactorsLearning_6" /> Language Barrier
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_7" name="cbFactorsLearning_7" className='add-only' value="FactorsLearning_7" /> Impaired ability of read/write
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_8" name="cbFactorsLearning_8" className='add-only' value="FactorsLearning_8" /> Sensory Impairment
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_9" name="cbFactorsLearning_9" className='add-only' value="FactorsLearning_9" /> Fatigue
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_10" name="cbFactorsLearning_10" className='add-only' value="FactorsLearning_10" /> Physical Disability
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_11" name="cbFactorsLearning_11" className='add-only' value="FactorsLearning_11" /> Acute/Chronic Organicity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFactorsLearning_12" name="cbFactorsLearning_12" className='add-only' value="FactorsLearning_12" /> Other:
                            <input type="text" id="txtFactorsLearning_12" name="txtFactorsLearning_12" className='add-only' />
                        </td>
                    </tr>
                </table>

                <h3>T.	SNAP: STRENGTHS, NEEDS, ABILITIES, PREFERENCES</h3>
                <p>
                    <span className='eleHeader'>What strengths does the Individual have that affects their quality of life?</span>
                    <span className='small'>(This should include family, friend, teacher supports, hobbies, community resources, education)</span>
                    <textarea id="txtWhatStrengths" name="txtWhatStrengths" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What is needed to increase the Individual's quality of life?</span>
                    <span className='small'>(Name specific interventions, resources for biological, psychological, and social/environmental barriers)</span>
                    <textarea id="txtIndividualQualityLife" name="txtIndividualQualityLife" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What are the Individual's abilities and skills that would help increase his/her quality of life?</span>
                    <span className='small'>(This should include personality traits, work skills, academic skills)</span>
                    <textarea id="txtIndividualAbilities" name="txtIndividualAbilities" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What are the family's strengths?</span>
                    <textarea id="txtFamilyStrengths" name="txtFamilyStrengths" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What are the Individual and family's expectation of and preferences for this service?</span>
                    <span className='small'>(This should include the Individual's own words of his/her expected outcome)</span>
                    <textarea id="txtIndividualExpectation" name="txtIndividualExpectation" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What are the Individual's hopes, dreams, or personal life goals?</span>
                    <span className='small'>(This should include the Individual's own words)</span>
                    <textarea id="txtIndividualHopes" name="txtIndividualHopes" className='add-only'></textarea>
                </p>
                <h3>U.	Hopes / Choices / Preferences / Desired Outcomes</h3>
                <p>
                    <span className='eleHeader'>What Hopes does the Individual have regarding their treatment?</span>
                    <span className='small'>(This should include family, friend, teacher  supports, hobbies, community resources, education)</span>
                    <textarea id="txtWhatHopes" name="txtWhatHopes" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What Choices does the Individual have regarding meeting his/her needs?</span>
                    <span className='small'>(Name specific resources, community opportunities, etc.)</span>
                    <textarea id="txtWhatChoices" name="txtWhatChoices" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What Preferences does the Individual have regarding his/her treatment?</span>
                    <span className='small'>(This should male/female community staff, meeting location and/or time, staff with specific specialty, etc.)</span>
                    <textarea id="txtWhatPreferences" name="txtWhatPreferences" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What are the Individual's Desired Outcomes for treatment?</span>
                    <span className='small'>(What does the Individual expect to achieve throughout his/her treatment?)</span>
                    <textarea id="txtWhatDesired" name="txtWhatDesired" className='add-only'></textarea>
                </p>
                <h3>V.	STAGE OF CHANGE</h3>
                <p>
                    <strong>STAGES OF CHANGE</strong>
                </p>
                <p>
                    <strong>Include:</strong>Inferring Need (Does the Individual feel they are successful and satisfied with their life?) Personal Awareness (Is the Individual aware of their needs, wants, desires, dreams, skills, aptitudes, decision making process, etc... .), Environmental Awareness (Does the Individual know the characteristics, requirements and conditions of what is available or exists in their living, learning, working and /or social environments?, Personal Closeness (Is the Individual close or trusting of others to help them?)
                </p>
                <p>
                    <strong>What Stage of Change is the Individual In:</strong>
                </p>
                <p>
                    <span className='eleHeader'>1.	Pre-Contemplation </span>
                    <span className='small'>(No intentions of changing)</span>
                    <textarea id="txtPreContemplation" name="txtPreContemplation" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>2.	Contemplation </span>
                    <span className='small'>(Recognizing there's a problem with no commitment to change)</span>
                    <textarea id="txtContemplation" name="txtContemplation" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>3.	Preparation </span>
                    <span className='small'>(Intent upon taking action soon and often report some steps in that direction)</span>
                    <textarea id="txtPreparation" name="txtPreparation" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>4.	Action

                    </span>
                    <span className='small'>(Is aware a problem exists and actively modifies their behavior, experiences and environment in order to overcome the problem. Commitment is clear and a great deal of effort is expended towards making changes)</span>
                    <textarea id="txtAction" name="txtAction" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>5.	Maintenance
                    </span>
                    <span className='small'>(Has made a sustained change wherein a new pattern of behavior has replaced the old. Behavior is firmly established and threat of relapse becomes less intense)</span>
                    <textarea id="txtMaintenance" name="txtMaintenance" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>6.	***(Relapse)</span>
                    <span className='small'></span>
                    <textarea id="txtRelapse" name="txtRelapse" className='add-only'></textarea>
                </p>
                <h3>W.	DSM-5/ ICD-10 DIAGNOSTIC IMPRESSION:</h3>
                <p>
                    <span className='eleHeader'>Co-Occurring Disorders Present:</span>
                    <span className='small'>(More than one diagnosis of any kind warrants a co-occurring disorder, not just substance abuse)
                    </span>
                    <input type="radio" id="rbCoOccurring_Yes" name="rbCoOccurring" className='add-only' value="Yes" /> Y
                    <input type="radio" id="rbCoOccurring_No" name="rbCoOccurring" className='add-only' value="No" /> N
                </p>
                <p>

                    <textarea id="txtDsmIcdDiagnosticImpression" name="txtDsmIcdDiagnosticImpression" className='add-only'></textarea>
                </p>
                <h3>X. INTERPRETIVE SUMMARY</h3>
                <p>
                    <span className='small'>(Please write a statement that integrates all assessments: describes central themes; reason (s) the individual is seeking services; individual's acceptance or understanding of his/her problems/needs and strategies for relapse prevention; individual's apparent strengths and functional limitations; description of potential barriers to community inclusion/integration and successful attainment of goals and movement towards recovery; complicating conditions/disorders, including a discussion of substance abuse patterns and serious medical conditions; explanation of choice goals to be worked on;  description of risk versus choice issues.  The summary should begin with a brief description of the individual)(Include SNAP as a part of summary).
                    </span>
                    <textarea id="txtInterpretiveSummary" name="txtInterpretiveSummary" className='add-only'></textarea>
                </p>
                <h3>Y.	CORE ADMISSION CRITERIA (DBHDD)</h3>
                <table>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbDbhdd_1" name="cbDbhdd_1" className='add-only' value="Dbhdd_1" />
                        </td>
                        <td className='w-700'>Individual is over the age of 18 years of age. If Individual is between the ages of 18-21 year the Individual is not in high school, in DJJ or DFCS custody, or it is otherwise developmentally/clinically indicated.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbDbhdd_2" name="cbDbhdd_2" className='add-only' value="Dbhdd_2" />
                        </td>
                        <td className='w-700'>Individual is a resident of the State of Georgia and is not under the care and custody of their custodial parent and/or guardian or a State child protective agency.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbDbhdd_3" name="cbDbhdd_3" className='add-only' value="Dbhdd_3" />
                        </td>
                        <td className='w-700'>Individual is not considered a danger to self or others.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbDbhdd_4" name="cbDbhdd_4" className='add-only' value="Dbhdd_4" />
                        </td>
                        <td className='w-700'>Individual has an identified and/or diagnosed involvement with drugs or alcohol.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbDbhdd_5" name="cbDbhdd_5" className='add-only' value="Dbhdd_5" />
                        </td>
                        <td className='w-700'>Individual agrees to actively participate in a treatment and/or behavioral management program.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbDbhdd_6" name="cbDbhdd_6" className='add-only' value="Dbhdd_6" />
                        </td>
                        <td className='w-700'>Individual has an identified and/or diagnosed mental illness.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbDbhdd_7" name="cbDbhdd_7" className='add-only' value="Dbhdd_7" />
                        </td>
                        <td className='w-700'>Treatment of Individual has been attempted at a lower level of care and been unsuccessful.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbDbhdd_8" name="cbDbhdd_8" className='add-only' value="Dbhdd_8" />
                        </td>
                        <td className='w-700'>Individual is in immediate need of crisis management skills.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbDbhdd_9" name="cbDbhdd_9" className='add-only' value="Dbhdd_9" />
                        </td>
                        <td className='w-700'>Individual does not have sufficient resources to cope with family crisis issues.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbDbhdd_10" name="cbDbhdd_10" className='add-only' value="Dbhdd_10" />
                        </td>
                        <td className='w-700'>Individual requires coordinated and supportive clinical interventions and support.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbDbhdd_11" name="cbDbhdd_11" className='add-only' value="Dbhdd_11" />
                        </td>
                        <td className='w-700'>Individual is willing to contract for services and participate in the program.
                        </td>
                    </tr>
                </table>

                <h3>Z.	ANSA</h3>
                <p>
                    <span className='eleHeader'>LIFE DOMAIN FUNCTIONING</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><strong>0 = no evidence of problems</strong></td>
                        <td className='w-375'><strong>1 = history, mild</strong></td>
                    </tr>
                    <tr>
                        <td className='w-375'><strong>2 = moderate</strong></td>
                        <td className='w-375'><strong>3 = severe</strong></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-390'>&nbsp;</td>
                        <td className='w-90'><strong>0</strong></td>
                        <td className='w-90'><strong>1</strong></td>
                        <td className='w-90'><strong>2</strong></td>
                        <td className='w-90'><strong>3</strong></td>
                    </tr>
                    <tr>
                        <td className='w-390'>Physical/Medical</td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainZero_1" name="rbLifeDomain_1" className='add-only' value="LifeDomainZero_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainOne_1" name="rbLifeDomain_1" className='add-only' value="LifeDomainOne_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainTwo_1" name="rbLifeDomain_1" className='add-only' value="LifeDomainTwo_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainThree_1" name="rbLifeDomain_1" className='add-only' value="LifeDomainThree_1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Family Functioning</td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainZero_2" name="rbLifeDomain_2" className='add-only' value="LifeDomainZero_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainOne_2" name="rbLifeDomain_2" className='add-only' value="LifeDomainOne_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainTwo_2" name="rbLifeDomain_2" className='add-only' value="LifeDomainTwo_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainThree_2" name="rbLifeDomain_2" className='add-only' value="LifeDomainThree_2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Employment<sup>1</sup></td>
                        <td className='w-90'>
                            <input type="radio" id="rbEmploymentNa" name="rbEmploymentNa" className='add-only' value="EmploymentNa_Na" /> N/A</td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainZero_3" name="rbLifeDomain_3" className='add-only' value="LifeDomainZero_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainOne_3" name="rbLifeDomain_3" className='add-only' value="LifeDomainOne_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainTwo_3" name="rbLifeDomain_3" className='add-only' value="LifeDomainTwo_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainThree_3" name="rbLifeDomain_3" className='add-only' value="LifeDomainThree_3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Social Functioning</td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainZero_4" name="rbLifeDomain_4" className='add-only' value="LifeDomainZero_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainOne_4" name="rbLifeDomain_4" className='add-only' value="LifeDomainOne_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainTwo_4" name="rbLifeDomain_4" className='add-only' value="LifeDomainTwo_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainThree_4" name="rbLifeDomain_4" className='add-only' value="LifeDomainThree_4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Recreational</td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainZero_5" name="rbLifeDomain_5" className='add-only' value="LifeDomainZero_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainOne_5" name="rbLifeDomain_5" className='add-only' value="LifeDomainOne_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainTwo_5" name="rbLifeDomain_5" className='add-only' value="LifeDomainTwo_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainThree_5" name="rbLifeDomain_5" className='add-only' value="LifeDomainThree_5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Intellectual/Developmental2</td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainZero_6" name="rbLifeDomain_6" className='add-only' value="LifeDomainZero_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainOne_6" name="rbLifeDomain_6" className='add-only' value="LifeDomainOne_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainTwo_6" name="rbLifeDomain_6" className='add-only' value="LifeDomainTwo_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainThree_6" name="rbLifeDomain_6" className='add-only' value="LifeDomainThree_6" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Sexuality</td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainZero_7" name="rbLifeDomain_7" className='add-only' value="LifeDomainZero_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainOne_7" name="rbLifeDomain_7" className='add-only' value="LifeDomainOne_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainTwo_7" name="rbLifeDomain_7" className='add-only' value="LifeDomainTwo_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainThree_7" name="rbLifeDomain_7" className='add-only' value="LifeDomainThree_7" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Independent Living Skills</td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainZero_8" name="rbLifeDomain_8" className='add-only' value="LifeDomainZero_8" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainOne_8" name="rbLifeDomain_8" className='add-only' value="LifeDomainOne_8" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainTwo_8" name="rbLifeDomain_8" className='add-only' value="LifeDomainTwo_8" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainThree_8" name="rbLifeDomain_8" className='add-only' value="LifeDomainThree_8" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Residential Stability</td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainZero_9" name="rbLifeDomain_9" className='add-only' value="LifeDomainZero_9" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainOne_9" name="rbLifeDomain_9" className='add-only' value="LifeDomainOne_9" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainTwo_9" name="rbLifeDomain_9" className='add-only' value="LifeDomainTwo_9" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainThree_9" name="rbLifeDomain_9" className='add-only' value="LifeDomainThree_9" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Legal</td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainZero_10" name="rbLifeDomain_10" className='add-only' value="LifeDomainZero_10" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainOne_10" name="rbLifeDomain_10" className='add-only' value="LifeDomainOne_10" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainTwo_10" name="rbLifeDomain_10" className='add-only' value="LifeDomainTwo_10" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainThree_10" name="rbLifeDomain_10" className='add-only' value="LifeDomainThree_10" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Sleep</td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainZero_11" name="rbLifeDomain_11" className='add-only' value="LifeDomainZero_11" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainOne_11" name="rbLifeDomain_11" className='add-only' value="LifeDomainOne_11" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainTwo_11" name="rbLifeDomain_11" className='add-only' value="LifeDomainTwo_11" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainThree_11" name="rbLifeDomain_11" className='add-only' value="LifeDomainThree_11" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Self Care</td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainZero_12" name="rbLifeDomain_12" className='add-only' value="LifeDomainZero_12" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainOne_12" name="rbLifeDomain_12" className='add-only' value="LifeDomainOne_12" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainTwo_12" name="rbLifeDomain_12" className='add-only' value="LifeDomainTwo_12" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainThree_12" name="rbLifeDomain_12" className='add-only' value="LifeDomainThree_12" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Decision-making</td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainZero_13" name="rbLifeDomain_13" className='add-only' value="LifeDomainZero_13" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainOne_13" name="rbLifeDomain_13" className='add-only' value="LifeDomainOne_13" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainTwo_13" name="rbLifeDomain_13" className='add-only' value="LifeDomainTwo_13" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainThree_13" name="rbLifeDomain_13" className='add-only' value="LifeDomainThree_13" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Involvement in Recovery</td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainZero_14" name="rbLifeDomain_14" className='add-only' value="LifeDomainZero_14" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainOne_14" name="rbLifeDomain_14" className='add-only' value="LifeDomainOne_14" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainTwo_14" name="rbLifeDomain_14" className='add-only' value="LifeDomainTwo_14" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainThree_14" name="rbLifeDomain_14" className='add-only' value="LifeDomainThree_14" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Transportation</td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainZero_15" name="rbLifeDomain_15" className='add-only' value="LifeDomainZero_15" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainOne_15" name="rbLifeDomain_15" className='add-only' value="LifeDomainOne_15" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainTwo_15" name="rbLifeDomain_15" className='add-only' value="LifeDomainTwo_15" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainThree_15" name="rbLifeDomain_15" className='add-only' value="LifeDomainThree_15" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Medication Compliance</td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainZero_16" name="rbLifeDomain_16" className='add-only' value="LifeDomainZero_16" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainOne_16" name="rbLifeDomain_16" className='add-only' value="LifeDomainOne_16" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainTwo_16" name="rbLifeDomain_16" className='add-only' value="LifeDomainTwo_16" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainThree_16" name="rbLifeDomain_16" className='add-only' value="LifeDomainThree_16" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Parental/Caregiver Role</td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentalCaregiverNa" name="rbParentalCaregiverNa" className='add-only' value="ParentalCaregiver_Na" /> N/A</td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainZero_17" name="rbLifeDomain_17" className='add-only' value="LifeDomainZero_17" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainOne_17" name="rbLifeDomain_17" className='add-only' value="LifeDomainOne_17" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainTwo_17" name="rbLifeDomain_17" className='add-only' value="LifeDomainTwo_17" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbLifeDomainThree_17" name="rbLifeDomain_17" className='add-only' value="LifeDomainThree_17" />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>BEHAVIORAL HEALTH NEEDS</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><strong>0 = no evidence</strong></td>
                    </tr>
                    <tr>
                        <td className='w-750'><strong>1 = history or sub-threshold, watch/prevent</strong></td>
                    </tr>
                    <tr>
                        <td className='w-750'><strong>2 = causing problems, consistent with diagnosable disorder</strong></td>
                    </tr>
                    <tr>
                        <td className='w-750'><strong>3 = causing severe/dangerous problems</strong></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-390'>&nbsp;</td>
                        <td className='w-90'><strong>0</strong></td>
                        <td className='w-90'><strong>1</strong></td>
                        <td className='w-90'><strong>2</strong></td>
                        <td className='w-90'><strong>3</strong></td>
                    </tr>
                    <tr>
                        <td className='w-390'>Psychosis</td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthZero_1" name="rbBehavioralHealth_1" className='add-only' value="BehavioralHealthZero_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthOne_1" name="rbBehavioralHealth_1" className='add-only' value="BehavioralHealthOne_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthTwo_1" name="rbBehavioralHealth_1" className='add-only' value="BehavioralHealthTwo_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthThree_1" name="rbBehavioralHealth_1" className='add-only' value="BehavioralHealthThree_1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Impulse Control	</td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthZero_2" name="rbBehavioralHealth_2" className='add-only' value="BehavioralHealthZero_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthOne_2" name="rbBehavioralHealth_2" className='add-only' value="BehavioralHealthOne_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthTwo_2" name="rbBehavioralHealth_2" className='add-only' value="BehavioralHealthTwo_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthThree_2" name="rbBehavioralHealth_2" className='add-only' value="BehavioralHealthThree_2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Depression</td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthZero_3" name="rbBehavioralHealth_3" className='add-only' value="BehavioralHealthZero_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthOne_3" name="rbBehavioralHealth_3" className='add-only' value="BehavioralHealthOne_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthTwo_3" name="rbBehavioralHealth_3" className='add-only' value="BehavioralHealthTwo_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthThree_3" name="rbBehavioralHealth_3" className='add-only' value="BehavioralHealthThree_3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Anxiety</td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthZero_4" name="rbBehavioralHealth_4" className='add-only' value="BehavioralHealthZero_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthOne_4" name="rbBehavioralHealth_4" className='add-only' value="BehavioralHealthOne_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthTwo_4" name="rbBehavioralHealth_4" className='add-only' value="BehavioralHealthTwo_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthThree_4" name="rbBehavioralHealth_4" className='add-only' value="BehavioralHealthThree_4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Interpersonal Problems</td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthZero_5" name="rbBehavioralHealth_5" className='add-only' value="BehavioralHealthZero_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthOne_5" name="rbBehavioralHealth_5" className='add-only' value="BehavioralHealthOne_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthTwo_5" name="rbBehavioralHealth_5" className='add-only' value="BehavioralHealthTwo_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthThree_5" name="rbBehavioralHealth_5" className='add-only' value="BehavioralHealthThree_5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Antisocial Behavior	</td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthZero_6" name="rbBehavioralHealth_6" className='add-only' value="BehavioralHealthZero_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthOne_6" name="rbBehavioralHealth_6" className='add-only' value="BehavioralHealthOne_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthTwo_6" name="rbBehavioralHealth_6" className='add-only' value="BehavioralHealthTwo_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthThree_6" name="rbBehavioralHealth_6" className='add-only' value="BehavioralHealthThree_6" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Adjustment to Trauma3	</td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthZero_7" name="rbBehavioralHealth_7" className='add-only' value="BehavioralHealthZero_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthOne_7" name="rbBehavioralHealth_7" className='add-only' value="BehavioralHealthOne_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthTwo_7" name="rbBehavioralHealth_7" className='add-only' value="BehavioralHealthTwo_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthThree_7" name="rbBehavioralHealth_7" className='add-only' value="BehavioralHealthThree_7" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Anger Control	</td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthZero_8" name="rbBehavioralHealth_8" className='add-only' value="BehavioralHealthZero_8" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthOne_8" name="rbBehavioralHealth_8" className='add-only' value="BehavioralHealthOne_8" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthTwo_8" name="rbBehavioralHealth_8" className='add-only' value="BehavioralHealthTwo_8" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthThree_8" name="rbBehavioralHealth_8" className='add-only' value="BehavioralHealthThree_8" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Eating Disturbance</td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthZero_9" name="rbBehavioralHealth_9" className='add-only' value="BehavioralHealthZero_9" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthOne_9" name="rbBehavioralHealth_9" className='add-only' value="BehavioralHealthOne_9" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthTwo_9" name="rbBehavioralHealth_9" className='add-only' value="BehavioralHealthTwo_9" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbBehavioralHealthThree_9" name="rbBehavioralHealth_9" className='add-only' value="BehavioralHealthThree_9" />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>STRENGTHS</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><strong>0 = centerpiece</strong></td>
                        <td className='w-375'><strong>1 = useful</strong></td>
                    </tr>
                    <tr>
                        <td className='w-375'><strong>2 = identified</strong></td>
                        <td className='w-375'><strong>3 = not yet identified</strong></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-300'>&nbsp;</td>
                        <td className='w-90'><strong>NA</strong></td>
                        <td className='w-90'><strong>0</strong></td>
                        <td className='w-90'><strong>1</strong></td>
                        <td className='w-90'><strong>2</strong></td>
                        <td className='w-90'><strong>3</strong></td>
                    </tr>
                    <tr>
                        <td className='w-300'>Family</td>
                        <td className='w-90'>&nbsp;</td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsZero_1" name="rbStrenghts_1" className='add-only' value="StrenghtsZero_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsOne_1" name="rbStrenghts_1" className='add-only' value="StrenghtsOne_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsTwo_1" name="rbStrenghts_1" className='add-only' value="StrenghtsTwo_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsThree_1" name="rbStrenghts_1" className='add-only' value="StrenghtsThree_1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Social Connectedness</td>
                        <td className='w-90'>&nbsp;</td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsZero_2" name="rbStrenghts_2" className='add-only' value="StrenghtsZero_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsOne_2" name="rbStrenghts_2" className='add-only' value="StrenghtsOne_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsTwo_2" name="rbStrenghts_2" className='add-only' value="StrenghtsTwo_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsThree_2" name="rbStrenghts_2" className='add-only' value="StrenghtsThree_2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Optimism</td>
                        <td className='w-90'>&nbsp;</td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsZero_3" name="rbStrenghts_3" className='add-only' value="StrenghtsZero_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsOne_3" name="rbStrenghts_3" className='add-only' value="StrenghtsOne_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsTwo_3" name="rbStrenghts_3" className='add-only' value="StrenghtsTwo_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsThree_3" name="rbStrenghts_3" className='add-only' value="StrenghtsThree_3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Talents/Interests</td>
                        <td className='w-90'>&nbsp;</td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsZero_4" name="rbStrenghts_4" className='add-only' value="StrenghtsZero_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsOne_4" name="rbStrenghts_4" className='add-only' value="StrenghtsOne_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsTwo_4" name="rbStrenghts_4" className='add-only' value="StrenghtsTwo_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsThree_4" name="rbStrenghts_4" className='add-only' value="StrenghtsThree_4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Educational</td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsNa_5" name="rbStrenghts_5" className='add-only' value="StrenghtsNa_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsZero_5" name="rbStrenghts_5" className='add-only' value="StrenghtsZero_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsOne_5" name="rbStrenghts_5" className='add-only' value="StrenghtsOne_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsTwo_5" name="rbStrenghts_5" className='add-only' value="StrenghtsTwo_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsThree_5" name="rbStrenghts_5" className='add-only' value="StrenghtsThree_5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Volunteering</td>
                        <td className='w-90'>&nbsp;</td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsZero_6" name="rbStrenghts_6" className='add-only' value="StrenghtsZero_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsOne_6" name="rbStrenghts_6" className='add-only' value="StrenghtsOne_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsTwo_6" name="rbStrenghts_6" className='add-only' value="StrenghtsTwo_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsThree_6" name="rbStrenghts_6" className='add-only' value="StrenghtsThree_6" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Job History</td>
                        <td className='w-90'>&nbsp;</td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsZero_7" name="rbStrenghts_7" className='add-only' value="StrenghtsZero_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsOne_7" name="rbStrenghts_7" className='add-only' value="StrenghtsOne_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsTwo_7" name="rbStrenghts_7" className='add-only' value="StrenghtsTwo_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsThree_7" name="rbStrenghts_7" className='add-only' value="StrenghtsThree_7" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Spiritual/Religious</td>
                        <td className='w-90'>&nbsp;</td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsZero_8" name="rbStrenghts_8" className='add-only' value="StrenghtsZero_8" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsOne_8" name="rbStrenghts_8" className='add-only' value="StrenghtsOne_8" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsTwo_8" name="rbStrenghts_8" className='add-only' value="StrenghtsTwo_8" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsThree_8" name="rbStrenghts_8" className='add-only' value="StrenghtsThree_8" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Community Connection</td>
                        <td className='w-90'>&nbsp;</td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsZero_9" name="rbStrenghts_9" className='add-only' value="StrenghtsZero_9" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsOne_9" name="rbStrenghts_9" className='add-only' value="StrenghtsOne_9" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsTwo_9" name="rbStrenghts_9" className='add-only' value="StrenghtsTwo_9" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsThree_9" name="rbStrenghts_9" className='add-only' value="StrenghtsThree_9" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Natural Supports</td>
                        <td className='w-90'>&nbsp;</td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsZero_10" name="rbStrenghts_10" className='add-only' value="StrenghtsZero_10" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsOne_10" name="rbStrenghts_10" className='add-only' value="StrenghtsOne_10" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsTwo_10" name="rbStrenghts_10" className='add-only' value="StrenghtsTwo_10" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsThree_10" name="rbStrenghts_10" className='add-only' value="StrenghtsThree_10" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Resiliency</td>
                        <td className='w-90'>&nbsp;</td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsZero_11" name="rbStrenghts_11" className='add-only' value="StrenghtsZero_11" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsOne_11" name="rbStrenghts_11" className='add-only' value="StrenghtsOne_11" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsTwo_11" name="rbStrenghts_11" className='add-only' value="StrenghtsTwo_11" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsThree_11" name="rbStrenghts_11" className='add-only' value="StrenghtsThree_11" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Resourcefulness</td>
                        <td className='w-90'>&nbsp;</td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsZero_12" name="rbStrenghts_12" className='add-only' value="StrenghtsZero_12" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsOne_12" name="rbStrenghts_12" className='add-only' value="StrenghtsOne_12" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsTwo_12" name="rbStrenghts_12" className='add-only' value="StrenghtsTwo_12" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbStrenghtsThree_12" name="rbStrenghts_12" className='add-only' value="StrenghtsThree_12" />
                        </td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>RISK BEHAVIORS</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><strong>0 = no evidence</strong></td>
                        <td className='w-375'><strong>1 = history, watch/prevent</strong></td>
                    </tr>
                    <tr>
                        <td className='w-375'><strong>2 = recent, act</strong></td>
                        <td className='w-375'><strong>3 = acute, act immediately</strong></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-390'>&nbsp;</td>
                        <td className='w-90'><strong>0</strong></td>
                        <td className='w-90'><strong>1</strong></td>
                        <td className='w-90'><strong>2</strong></td>
                        <td className='w-90'><strong>3</strong></td>
                    </tr>
                    <tr>
                        <td className='w-390'>Suicide Risk5</td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskZero_1" name="rbRisk_1" className='add-only' value="RiskZero_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskOne_1" name="rbRisk_1" className='add-only' value="RiskOne_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskTwo_1" name="rbRisk_1" className='add-only' value="RiskTwo_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskThree_1" name="rbRisk_1" className='add-only' value="RiskThree_1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Danger to Others6</td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskZero_2" name="rbRisk_2" className='add-only' value="RiskZero_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskOne_2" name="rbRisk_2" className='add-only' value="RiskOne_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskTwo_2" name="rbRisk_2" className='add-only' value="RiskTwo_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskThree_2" name="rbRisk_2" className='add-only' value="RiskThree_2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Self Injurious Behavior</td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskZero_3" name="rbRisk_3" className='add-only' value="RiskZero_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskOne_3" name="rbRisk_3" className='add-only' value="RiskOne_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskTwo_3" name="rbRisk_3" className='add-only' value="RiskTwo_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskThree_3" name="rbRisk_3" className='add-only' value="RiskThree_3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Other Self Harm</td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskZero_4" name="rbRisk_4" className='add-only' value="RiskZero_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskOne_4" name="rbRisk_4" className='add-only' value="RiskOne_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskTwo_4" name="rbRisk_4" className='add-only' value="RiskTwo_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskThree_4" name="rbRisk_4" className='add-only' value="RiskThree_4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Exploitation</td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskZero_5" name="rbRisk_5" className='add-only' value="RiskZero_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskOne_5" name="rbRisk_5" className='add-only' value="RiskOne_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskTwo_5" name="rbRisk_5" className='add-only' value="RiskTwo_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskThree_5" name="rbRisk_5" className='add-only' value="RiskThree_5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Gambling</td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskZero_6" name="rbRisk_6" className='add-only' value="RiskZero_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskOne_6" name="rbRisk_6" className='add-only' value="RiskOne_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskTwo_6" name="rbRisk_6" className='add-only' value="RiskTwo_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskThree_6" name="rbRisk_6" className='add-only' value="RiskThree_6" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Sexual Aggression7</td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskZero_7" name="rbRisk_7" className='add-only' value="RiskZero_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskOne_7" name="rbRisk_7" className='add-only' value="RiskOne_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskTwo_7" name="rbRisk_7" className='add-only' value="RiskTwo_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskThree_7" name="rbRisk_7" className='add-only' value="RiskThree_7" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Criminal Behavior8</td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskZero_8" name="rbRisk_8" className='add-only' value="RiskZero_8" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskOne_8" name="rbRisk_8" className='add-only' value="RiskOne_8" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskTwo_8" name="rbRisk_8" className='add-only' value="RiskTwo_8" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbRiskThree_8" name="rbRisk_8" className='add-only' value="RiskThree_8" />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>ACCULTURATION</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><strong>0 = no evidence </strong></td>
                        <td className='w-375'><strong>1 = minimal needs</strong></td>
                    </tr>
                    <tr>
                        <td className='w-375'><strong>2 = moderate needs</strong></td>
                        <td className='w-375'><strong>3 = severe needs</strong></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-390'>&nbsp;</td>
                        <td className='w-90'><strong>0</strong></td>
                        <td className='w-90'><strong>1</strong></td>
                        <td className='w-90'><strong>2</strong></td>
                        <td className='w-90'><strong>3</strong></td>
                    </tr>
                    <tr>
                        <td className='w-390'>Language</td>
                        <td className='w-90'>
                            <input type="radio" id="rbAcculturationZero_1" name="rbAcculturation_1" className='add-only' value="AcculturationZero_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAcculturationOne_1" name="rbAcculturation_1" className='add-only' value="AcculturationOne_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAcculturationTwo_1" name="rbAcculturation_1" className='add-only' value="AcculturationTwo_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAcculturationThree_1" name="rbAcculturation_1" className='add-only' value="AcculturationThree_1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Cultural Identity</td>
                        <td className='w-90'>
                            <input type="radio" id="rbAcculturationZero_2" name="rbAcculturation_2" className='add-only' value="AcculturationZero_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAcculturationOne_2" name="rbAcculturation_2" className='add-only' value="AcculturationOne_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAcculturationTwo_2" name="rbAcculturation_2" className='add-only' value="AcculturationTwo_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAcculturationThree_2" name="rbAcculturation_2" className='add-only' value="AcculturationThree_2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Ritual</td>
                        <td className='w-90'>
                            <input type="radio" id="rbAcculturationZero_3" name="rbAcculturation_3" className='add-only' value="AcculturationZero_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAcculturationOne_3" name="rbAcculturation_3" className='add-only' value="AcculturationOne_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAcculturationTwo_3" name="rbAcculturation_3" className='add-only' value="AcculturationTwo_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAcculturationThree_3" name="rbAcculturation_3" className='add-only' value="AcculturationThree_3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Cultural Stress</td>
                        <td className='w-90'>
                            <input type="radio" id="rbAcculturationZero_4" name="rbAcculturation_4" className='add-only' value="AcculturationZero_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAcculturationOne_4" name="rbAcculturation_4" className='add-only' value="AcculturationOne_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAcculturationTwo_4" name="rbAcculturation_4" className='add-only' value="AcculturationTwo_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAcculturationThree_4" name="rbAcculturation_4" className='add-only' value="AcculturationThree_4" />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Substance Use</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><strong>0 = no evidence</strong></td>
                        <td className='w-375'><strong>1 = history, watch/prevent</strong></td>
                    </tr>
                    <tr>
                        <td className='w-375'><strong>2 = recent, act</strong></td>
                        <td className='w-375'><strong>3 = acute, act immediately</strong></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-390'>&nbsp;</td>
                        <td className='w-90'><strong>0</strong></td>
                        <td className='w-90'><strong>1</strong></td>
                        <td className='w-90'><strong>2</strong></td>
                        <td className='w-90'><strong>3</strong></td>
                    </tr>
                    <tr>
                        <td className='w-390'>Substance Use</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseZero_1" name="rbSubstanceUse_1" className='add-only' value="SubstanceUseZero_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseOne_1" name="rbSubstanceUse_1" className='add-only' value="SubstanceUseOne_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseTwo_1" name="rbSubstanceUse_1" className='add-only' value="SubstanceUseTwo_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseThree_1" name="rbSubstanceUse_1" className='add-only' value="SubstanceUseThree_1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Severity of Use</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseZero_2" name="rbSubstanceUse_2" className='add-only' value="SubstanceUseZero_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseOne_2" name="rbSubstanceUse_2" className='add-only' value="SubstanceUseOne_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseTwo_2" name="rbSubstanceUse_2" className='add-only' value="SubstanceUseTwo_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseThree_2" name="rbSubstanceUse_2" className='add-only' value="SubstanceUseThree_2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Duration of Use</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseZero_3" name="rbSubstanceUse_3" className='add-only' value="SubstanceUseZero_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseOne_3" name="rbSubstanceUse_3" className='add-only' value="SubstanceUseOne_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseTwo_3" name="rbSubstanceUse_3" className='add-only' value="SubstanceUseTwo_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseThree_3" name="rbSubstanceUse_3" className='add-only' value="SubstanceUseThree_3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Peer Influences</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseZero_4" name="rbSubstanceUse_4" className='add-only' value="SubstanceUseZero_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseOne_4" name="rbSubstanceUse_4" className='add-only' value="SubstanceUseOne_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseTwo_4" name="rbSubstanceUse_4" className='add-only' value="SubstanceUseTwo_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseThree_4" name="rbSubstanceUse_4" className='add-only' value="SubstanceUseThree_4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Environmental Influences</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseZero_5" name="rbSubstanceUse_5" className='add-only' value="SubstanceUseZero_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseOne_5" name="rbSubstanceUse_5" className='add-only' value="SubstanceUseOne_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseTwo_5" name="rbSubstanceUse_5" className='add-only' value="SubstanceUseTwo_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseThree_5" name="rbSubstanceUse_5" className='add-only' value="SubstanceUseThree_5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Recovery Support in Community</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseZero_6" name="rbSubstanceUse_6" className='add-only' value="SubstanceUseZero_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseOne_6" name="rbSubstanceUse_6" className='add-only' value="SubstanceUseOne_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseTwo_6" name="rbSubstanceUse_6" className='add-only' value="SubstanceUseTwo_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseThree_6" name="rbSubstanceUse_6" className='add-only' value="SubstanceUseThree_6" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Stage of Recovery</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseZero_7" name="rbSubstanceUse_7" className='add-only' value="SubstanceUseZero_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseOne_7" name="rbSubstanceUse_7" className='add-only' value="SubstanceUseOne_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseTwo_7" name="rbSubstanceUse_7" className='add-only' value="SubstanceUseTwo_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSubstanceUseThree_7" name="rbSubstanceUse_7" className='add-only' value="SubstanceUseThree_7" />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Optional CAREGIVER STRENGTHS & NEEDS</span>
                    X Not applicable – no caregiver identified
                </p>
                <table>
                    <tr>
                        <td className='w-375'><strong>0 = no evidence</strong></td>
                        <td className='w-375'><strong>1 = minimal needs</strong></td>
                    </tr>
                    <tr>
                        <td className='w-375'><strong>2 = moderate needs</strong></td>
                        <td className='w-375'><strong>3 = severe needs</strong></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-390'>&nbsp;</td>
                        <td className='w-90'><strong>0</strong></td>
                        <td className='w-90'><strong>1</strong></td>
                        <td className='w-90'><strong>2</strong></td>
                        <td className='w-90'><strong>3</strong></td>
                    </tr>
                    <tr>
                        <td className='w-390'>Physical/Behavioral Health</td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalZero_1" name="rbOptional_1" className='add-only' value="OptionalZero_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalOne_1" name="rbOptional_1" className='add-only' value="OptionalOne_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalTwo_1" name="rbOptional_1" className='add-only' value="OptionalTwo_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalThree_1" name="rbOptional_1" className='add-only' value="OptionalThree_1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Involvement</td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalZero_2" name="rbOptional_2" className='add-only' value="OptionalZero_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalOne_2" name="rbOptional_2" className='add-only' value="OptionalOne_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalTwo_2" name="rbOptional_2" className='add-only' value="OptionalTwo_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalThree_2" name="rbOptional_2" className='add-only' value="OptionalThree_2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Knowledge</td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalZero_3" name="rbOptional_3" className='add-only' value="OptionalZero_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalOne_3" name="rbOptional_3" className='add-only' value="OptionalOne_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalTwo_3" name="rbOptional_3" className='add-only' value="OptionalTwo_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalThree_3" name="rbOptional_3" className='add-only' value="OptionalThree_3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Social Resources</td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalZero_4" name="rbOptional_4" className='add-only' value="OptionalZero_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalOne_4" name="rbOptional_4" className='add-only' value="OptionalOne_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalTwo_4" name="rbOptional_4" className='add-only' value="OptionalTwo_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalThree_4" name="rbOptional_4" className='add-only' value="OptionalThree_4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Family Stress</td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalZero_5" name="rbOptional_5" className='add-only' value="OptionalZero_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalOne_5" name="rbOptional_5" className='add-only' value="OptionalOne_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalTwo_5" name="rbOptional_5" className='add-only' value="OptionalTwo_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalThree_5" name="rbOptional_5" className='add-only' value="OptionalThree_5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Safety</td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalZero_6" name="rbOptional_6" className='add-only' value="OptionalZero_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalOne_6" name="rbOptional_6" className='add-only' value="OptionalOne_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalTwo_6" name="rbOptional_6" className='add-only' value="OptionalTwo_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbOptionalThree_6" name="rbOptional_6" className='add-only' value="OptionalThree_6" />
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>
                        <center>MODULES</center>
                        <br />See Back for Module Scoring
                    </strong>
                    <ul>
                        <li><sup>1</sup>  go to Vocational/Career Module</li>
                        <li><sup>2</sup>  go to DD Module</li>
                        <li><sup>3</sup>  go to Trauma Module</li>
                        <li><sup>4</sup>  go to Suicide Module</li>
                        <li><sup>5</sup>  go to Dangerousness Module</li>
                        <li><sup>6</sup>  go to Sex Offender Module</li>
                        <li><sup>7</sup>  go to Crime Module</li>
                    </ul> 

                    Shaded ratings trigger required Extension Modules on next page.

                </p>

                <h3>Extension MODULES</h3>
                <p>
                    <span className='eleHeader'>VOCATIONAL/CAREER</span>
                </p>
                <table>
                    <tr>
                        <td className='w-300'>&nbsp;</td>
                        <td className='w-90'><strong>NA</strong></td>
                        <td className='w-90'><strong>0</strong></td>
                        <td className='w-90'><strong>1</strong></td>
                        <td className='w-90'><strong>2</strong></td>
                        <td className='w-90'><strong>3</strong></td>
                    </tr>
                    <tr>
                        <td className='w-300'>Career Aspirations</td>
                        <td className='w-90'>&nbsp;</td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalZero_1" name="rbVocational_1" className='add-only' value="VocationalZero_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalOne_1" name="rbVocational_1" className='add-only' value="VocationalOne_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalTwo_1" name="rbVocational_1" className='add-only' value="VocationalTwo_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalThree_1" name="rbVocational_1" className='add-only' value="VocationalThree_1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Job Time</td>
                        <td className='w-90'>&nbsp;</td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalZero_2" name="rbVocational_2" className='add-only' value="VocationalZero_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalOne_2" name="rbVocational_2" className='add-only' value="VocationalOne_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalTwo_2" name="rbVocational_2" className='add-only' value="VocationalTwo_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalThree_2" name="rbVocational_2" className='add-only' value="VocationalThree_2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Job Attendance</td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalNa_3" name="rbVocational_3" className='add-only' value="VocationalNa_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalZero_3" name="rbVocational_3" className='add-only' value="VocationalZero_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalOne_3" name="rbVocational_3" className='add-only' value="VocationalOne_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalTwo_3" name="rbVocational_3" className='add-only' value="VocationalTwo_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalThree_3" name="rbVocational_3" className='add-only' value="VocationalThree_3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Job Performance </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalNa_4" name="rbVocational_4" className='add-only' value="VocationalNa_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalZero_4" name="rbVocational_4" className='add-only' value="VocationalZero_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalOne_4" name="rbVocational_4" className='add-only' value="VocationalOne_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalTwo_4" name="rbVocational_4" className='add-only' value="VocationalTwo_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalThree_4" name="rbVocational_4" className='add-only' value="VocationalThree_4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Job Relations</td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalNa_5" name="rbVocational_5" className='add-only' value="VocationalNa_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalZero_5" name="rbVocational_5" className='add-only' value="VocationalZero_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalOne_5" name="rbVocational_5" className='add-only' value="VocationalOne_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalTwo_5" name="rbVocational_5" className='add-only' value="VocationalTwo_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalThree_5" name="rbVocational_5" className='add-only' value="VocationalThree_5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Job Skills</td>
                        <td className='w-90'>&nbsp;</td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalZero_6" name="rbVocational_6" className='add-only' value="VocationalZero_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalOne_6" name="rbVocational_6" className='add-only' value="VocationalOne_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalTwo_6" name="rbVocational_6" className='add-only' value="VocationalTwo_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbVocationalThree_6" name="rbVocational_6" className='add-only' value="VocationalThree_6" />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>SUICIDE MODULE</span>
                </p>
                <table>
                    <tr>
                        <td className='w-390'>&nbsp;</td>
                        <td className='w-90'><strong>0</strong></td>
                        <td className='w-90'><strong>1</strong></td>
                        <td className='w-90'><strong>2</strong></td>
                        <td className='w-90'><strong>3</strong></td>
                    </tr>
                    <tr>
                        <td className='w-390'>Suicide Ideation</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSuicideModuleZero_1" name="rbSuicideModule_1" className='add-only' value="SuicideModuleZero_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSuicideModuleOne_1" name="rbSuicideModule_1" className='add-only' value="SuicideModuleOne_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSuicideModuleTwo_1" name="rbSuicideModule_1" className='add-only' value="SuicideModuleTwo_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSuicideModuleThree_1" name="rbSuicideModule_1" className='add-only' value="SuicideModuleThree_1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Suicide Intent</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSuicideModuleZero_2" name="rbSuicideModule_2" className='add-only' value="SuicideModuleZero_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSuicideModuleOne_2" name="rbSuicideModule_2" className='add-only' value="SuicideModuleOne_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSuicideModuleTwo_2" name="rbSuicideModule_2" className='add-only' value="SuicideModuleTwo_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSuicideModuleThree_2" name="rbSuicideModule_2" className='add-only' value="SuicideModuleThree_2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Suicide Planning</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSuicideModuleZero_3" name="rbSuicideModule_3" className='add-only' value="SuicideModuleZero_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSuicideModuleOne_3" name="rbSuicideModule_3" className='add-only' value="SuicideModuleOne_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSuicideModuleTwo_3" name="rbSuicideModule_3" className='add-only' value="SuicideModuleTwo_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSuicideModuleThree_3" name="rbSuicideModule_3" className='add-only' value="SuicideModuleThree_3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Suicide History</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSuicideModuleZero_4" name="rbSuicideModule_4" className='add-only' value="SuicideModuleZero_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSuicideModuleOne_4" name="rbSuicideModule_4" className='add-only' value="SuicideModuleOne_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSuicideModuleTwo_4" name="rbSuicideModule_4" className='add-only' value="SuicideModuleTwo_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSuicideModuleThree_4" name="rbSuicideModule_4" className='add-only' value="SuicideModuleThree_4" />
                        </td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>DEVELOPMENTAL NEEDS  (DD)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-390'>&nbsp;</td>
                        <td className='w-90'><strong>0</strong></td>
                        <td className='w-90'><strong>1</strong></td>
                        <td className='w-90'><strong>2</strong></td>
                        <td className='w-90'><strong>3</strong></td>
                    </tr>
                    <tr>
                        <td className='w-390'>Cognitive</td>
                        <td className='w-90'>
                            <input type="radio" id="rbDevelopmentalZero_1" name="rbDevelopmental_1" className='add-only' value="DevelopmentalZero_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDevelopmentalOne_1" name="rbDevelopmental_1" className='add-only' value="DevelopmentalOne_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDevelopmentalTwo_1" name="rbDevelopmental_1" className='add-only' value="DevelopmentalTwo_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDevelopmentalThree_1" name="rbDevelopmental_1" className='add-only' value="DevelopmentalThree_1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Communication</td>
                        <td className='w-90'>
                            <input type="radio" id="rbDevelopmentalZero_2" name="rbDevelopmental_2" className='add-only' value="DevelopmentalZero_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDevelopmentalOne_2" name="rbDevelopmental_2" className='add-only' value="DevelopmentalOne_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDevelopmentalTwo_2" name="rbDevelopmental_2" className='add-only' value="DevelopmentalTwo_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDevelopmentalThree_2" name="rbDevelopmental_2" className='add-only' value="DevelopmentalThree_2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Developmental</td>
                        <td className='w-90'>
                            <input type="radio" id="rbDevelopmentalZero_3" name="rbDevelopmental_3" className='add-only' value="DevelopmentalZero_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDevelopmentalOne_3" name="rbDevelopmental_3" className='add-only' value="DevelopmentalOne_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDevelopmentalTwo_3" name="rbDevelopmental_3" className='add-only' value="DevelopmentalTwo_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDevelopmentalThree_3" name="rbDevelopmental_3" className='add-only' value="DevelopmentalThree_3" />
                        </td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>DANGEROUSNESS MODULE</span>
                </p>
                <table>
                    <tr>
                        <td className='w-390'>&nbsp;</td>
                        <td className='w-90'><strong>0</strong></td>
                        <td className='w-90'><strong>1</strong></td>
                        <td className='w-90'><strong>2</strong></td>
                        <td className='w-90'><strong>3</strong></td>
                    </tr>
                    <tr>
                        <td className='w-390'>Intent</td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleZero_1" name="rbDangerousnessModule_1" className='add-only' value="DangerousnessModuleZero_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleOne_1" name="rbDangerousnessModule_1" className='add-only' value="DangerousnessModuleOne_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleTwo_1" name="rbDangerousnessModule_1" className='add-only' value="DangerousnessModuleTwo_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleThree_1" name="rbDangerousnessModule_1" className='add-only' value="DangerousnessModuleThree_1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Planning</td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleZero_2" name="rbDangerousnessModule_2" className='add-only' value="DangerousnessModuleZero_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleOne_2" name="rbDangerousnessModule_2" className='add-only' value="DangerousnessModuleOne_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleTwo_2" name="rbDangerousnessModule_2" className='add-only' value="DangerousnessModuleTwo_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleThree_2" name="rbDangerousnessModule_2" className='add-only' value="DangerousnessModuleThree_2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Violence History</td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleZero_3" name="rbDangerousnessModule_3" className='add-only' value="DangerousnessModuleZero_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleOne_3" name="rbDangerousnessModule_3" className='add-only' value="DangerousnessModuleOne_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleTwo_3" name="rbDangerousnessModule_3" className='add-only' value="DangerousnessModuleTwo_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleThree_3" name="rbDangerousnessModule_3" className='add-only' value="DangerousnessModuleThree_3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Frustration Management</td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleZero_4" name="rbDangerousnessModule_4" className='add-only' value="DangerousnessModuleZero_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleOne_4" name="rbDangerousnessModule_4" className='add-only' value="DangerousnessModuleOne_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleTwo_4" name="rbDangerousnessModule_4" className='add-only' value="DangerousnessModuleTwo_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleThree_4" name="rbDangerousnessModule_4" className='add-only' value="DangerousnessModuleThree_4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Hostility</td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleZero_5" name="rbDangerousnessModule_5" className='add-only' value="DangerousnessModuleZero_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleOne_5" name="rbDangerousnessModule_5" className='add-only' value="DangerousnessModuleOne_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleTwo_5" name="rbDangerousnessModule_5" className='add-only' value="DangerousnessModuleTwo_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleThree_5" name="rbDangerousnessModule_5" className='add-only' value="DangerousnessModuleThree_5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Paranoid Thinking</td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleZero_6" name="rbDangerousnessModule_6" className='add-only' value="DangerousnessModuleZero_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleOne_6" name="rbDangerousnessModule_6" className='add-only' value="DangerousnessModuleOne_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleTwo_6" name="rbDangerousnessModule_6" className='add-only' value="DangerousnessModuleTwo_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleThree_6" name="rbDangerousnessModule_6" className='add-only' value="DangerousnessModuleThree_6" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Secondary gains from anger</td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleZero_7" name="rbDangerousnessModule_7" className='add-only' value="DangerousnessModuleZero_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleOne_7" name="rbDangerousnessModule_7" className='add-only' value="DangerousnessModuleOne_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleTwo_7" name="rbDangerousnessModule_7" className='add-only' value="DangerousnessModuleTwo_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleThree_7" name="rbDangerousnessModule_7" className='add-only' value="DangerousnessModuleThree_7" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Violent Thinking</td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleZero_8" name="rbDangerousnessModule_8" className='add-only' value="DangerousnessModuleZero_8" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleOne_8" name="rbDangerousnessModule_8" className='add-only' value="DangerousnessModuleOne_8" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleTwo_8" name="rbDangerousnessModule_8" className='add-only' value="DangerousnessModuleTwo_8" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbDangerousnessModuleThree_8" name="rbDangerousnessModule_8" className='add-only' value="DangerousnessModuleThree_8" />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>PARENTING/CAREGIVER ROLE EXTENSION MODULE</span>
                </p>
                <table>
                    <tr>
                        <td className='w-390'>&nbsp;</td>
                        <td className='w-90'><strong>0</strong></td>
                        <td className='w-90'><strong>1</strong></td>
                        <td className='w-90'><strong>2</strong></td>
                        <td className='w-90'><strong>3</strong></td>
                    </tr>
                    <tr>
                        <td className='w-390'>Knowledge of Needs</td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentingZero_1" name="rbParenting_1" className='add-only' value="ParentingZero_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentingOne_1" name="rbParenting_1" className='add-only' value="ParentingOne_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentingTwo_1" name="rbParenting_1" className='add-only' value="ParentingTwo_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentingThree_1" name="rbParenting_1" className='add-only' value="ParentingThree_1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Supervision</td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentingZero_2" name="rbParenting_2" className='add-only' value="ParentingZero_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentingOne_2" name="rbParenting_2" className='add-only' value="ParentingOne_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentingTwo_2" name="rbParenting_2" className='add-only' value="ParentingTwo_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentingThree_2" name="rbParenting_2" className='add-only' value="ParentingThree_2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Involvement with Care</td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentingZero_3" name="rbParenting_3" className='add-only' value="ParentingZero_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentingOne_3" name="rbParenting_3" className='add-only' value="ParentingOne_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentingTwo_3" name="rbParenting_3" className='add-only' value="ParentingTwo_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentingThree_3" name="rbParenting_3" className='add-only' value="ParentingThree_3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Organization</td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentingZero_4" name="rbParenting_4" className='add-only' value="ParentingZero_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentingOne_4" name="rbParenting_4" className='add-only' value="ParentingOne_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentingTwo_4" name="rbParenting_4" className='add-only' value="ParentingTwo_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentingThree_4" name="rbParenting_4" className='add-only' value="ParentingThree_4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Marital/Partner Violence Home</td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentingZero_5" name="rbParenting_5" className='add-only' value="ParentingZero_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentingOne_5" name="rbParenting_5" className='add-only' value="ParentingOne_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentingTwo_5" name="rbParenting_5" className='add-only' value="ParentingTwo_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbParentingThree_5" name="rbParenting_5" className='add-only' value="ParentingThree_5" />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Resiliency Factors</span>
                </p>
                <table>
                    <tr>
                        <td className='w-390'>&nbsp;</td>
                        <td className='w-90'><strong>0</strong></td>
                        <td className='w-90'><strong>1</strong></td>
                        <td className='w-90'><strong>2</strong></td>
                        <td className='w-90'><strong>3</strong></td>
                    </tr>
                    <tr>
                        <td className='w-390'>Aware of violence potential</td>
                        <td className='w-90'>
                            <input type="radio" id="rbResiliencyZero_1" name="rbResiliency_1" className='add-only' value="ResiliencyZero_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbResiliencyOne_1" name="rbResiliency_1" className='add-only' value="ResiliencyOne_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbResiliencyTwo_1" name="rbResiliency_1" className='add-only' value="ResiliencyTwo_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbResiliencyThree_1" name="rbResiliency_1" className='add-only' value="ResiliencyThree_1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Response to Consequences</td>
                        <td className='w-90'>
                            <input type="radio" id="rbResiliencyZero_2" name="rbResiliency_2" className='add-only' value="ResiliencyZero_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbResiliencyOne_2" name="rbResiliency_2" className='add-only' value="ResiliencyOne_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbResiliencyTwo_2" name="rbResiliency_2" className='add-only' value="ResiliencyTwo_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbResiliencyThree_2" name="rbResiliency_2" className='add-only' value="ResiliencyThree_2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Commitment to Self-Control</td>
                        <td className='w-90'>
                            <input type="radio" id="rbResiliencyZero_3" name="rbResiliency_3" className='add-only' value="ResiliencyZero_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbResiliencyOne_3" name="rbResiliency_3" className='add-only' value="ResiliencyOne_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbResiliencyTwo_3" name="rbResiliency_3" className='add-only' value="ResiliencyTwo_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbResiliencyThree_3" name="rbResiliency_3" className='add-only' value="ResiliencyThree_3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Treatment Involvement</td>
                        <td className='w-90'>
                            <input type="radio" id="rbResiliencyZero_4" name="rbResiliency_4" className='add-only' value="ResiliencyZero_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbResiliencyOne_4" name="rbResiliency_4" className='add-only' value="ResiliencyOne_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbResiliencyTwo_4" name="rbResiliency_4" className='add-only' value="ResiliencyTwo_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbResiliencyThree_4" name="rbResiliency_4" className='add-only' value="ResiliencyThree_4" />
                        </td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>TRAUMA
                        <span className='small'>(Characteristics of the trauma experience)</span>
                    </span>
                </p>
                <table>
                    <tr>
                        <td className='w-390'>&nbsp;</td>
                        <td className='w-90'><strong>0</strong></td>
                        <td className='w-90'><strong>1</strong></td>
                        <td className='w-90'><strong>2</strong></td>
                        <td className='w-90'><strong>3</strong></td>
                    </tr>
                    <tr>
                        <td className='w-390'>Sexual Abuse</td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaZero_1" name="rbTrauma_1" className='add-only' value="TraumaZero_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaOne_1" name="rbTrauma_1" className='add-only' value="TraumaOne_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaTwo_1" name="rbTrauma_1" className='add-only' value="TraumaTwo_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaThree_1" name="rbTrauma_1" className='add-only' value="TraumaThree_1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Physical Abuse</td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaZero_2" name="rbTrauma_2" className='add-only' value="TraumaZero_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaOne_2" name="rbTrauma_2" className='add-only' value="TraumaOne_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaTwo_2" name="rbTrauma_2" className='add-only' value="TraumaTwo_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaThree_2" name="rbTrauma_2" className='add-only' value="TraumaThree_2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Emotional Abuse</td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaZero_3" name="rbTrauma_3" className='add-only' value="TraumaZero_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaOne_3" name="rbTrauma_3" className='add-only' value="TraumaOne_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaTwo_3" name="rbTrauma_3" className='add-only' value="TraumaTwo_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaThree_3" name="rbTrauma_3" className='add-only' value="TraumaThree_3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Medical Trauma</td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaZero_4" name="rbTrauma_4" className='add-only' value="TraumaZero_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaOne_4" name="rbTrauma_4" className='add-only' value="TraumaOne_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaTwo_4" name="rbTrauma_4" className='add-only' value="TraumaTwo_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaThree_4" name="rbTrauma_4" className='add-only' value="TraumaThree_4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Natural/Manmade Disaster</td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaZero_5" name="rbTrauma_5" className='add-only' value="TraumaZero_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaOne_5" name="rbTrauma_5" className='add-only' value="TraumaOne_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaTwo_5" name="rbTrauma_5" className='add-only' value="TraumaTwo_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaThree_5" name="rbTrauma_5" className='add-only' value="TraumaThree_5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Witness/Victim to Family Violence</td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaZero_6" name="rbTrauma_6" className='add-only' value="TraumaZero_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaOne_6" name="rbTrauma_6" className='add-only' value="TraumaOne_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaTwo_6" name="rbTrauma_6" className='add-only' value="TraumaTwo_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaThree_6" name="rbTrauma_6" className='add-only' value="TraumaThree_6" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Witness/Victim to Community Violence</td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaZero_7" name="rbTrauma_7" className='add-only' value="TraumaZero_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaOne_7" name="rbTrauma_7" className='add-only' value="TraumaOne_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaTwo_7" name="rbTrauma_7" className='add-only' value="TraumaTwo_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbTraumaThree_7" name="rbTrauma_7" className='add-only' value="TraumaThree_7" />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>SEXUALLY AGGRESSIVE BEHAVIOR (SAB)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-390'>&nbsp;</td>
                        <td className='w-90'><strong>0</strong></td>
                        <td className='w-90'><strong>1</strong></td>
                        <td className='w-90'><strong>2</strong></td>
                        <td className='w-90'><strong>3</strong></td>
                    </tr>
                    <tr>
                        <td className='w-390'>Relationship</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabZero_1" name="rbSab_1" className='add-only' value="SabZero_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabOne_1" name="rbSab_1" className='add-only' value="SabOne_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabTwo_1" name="rbSab_1" className='add-only' value="SabTwo_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabThree_1" name="rbSab_1" className='add-only' value="SabThree_1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Physical Force/Threat</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabZero_2" name="rbSab_2" className='add-only' value="SabZero_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabOne_2" name="rbSab_2" className='add-only' value="SabOne_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabTwo_2" name="rbSab_2" className='add-only' value="SabTwo_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabThree_2" name="rbSab_2" className='add-only' value="SabThree_2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Planning</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabZero_3" name="rbSab_3" className='add-only' value="SabZero_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabOne_3" name="rbSab_3" className='add-only' value="SabOne_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabTwo_3" name="rbSab_3" className='add-only' value="SabTwo_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabThree_3" name="rbSab_3" className='add-only' value="SabThree_3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Age Differential</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabZero_4" name="rbSab_4" className='add-only' value="SabZero_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabOne_4" name="rbSab_4" className='add-only' value="SabOne_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabTwo_4" name="rbSab_4" className='add-only' value="SabTwo_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabThree_4" name="rbSab_4" className='add-only' value="SabThree_4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Type of Sex Act</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabZero_5" name="rbSab_5" className='add-only' value="SabZero_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabOne_5" name="rbSab_5" className='add-only' value="SabOne_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabTwo_5" name="rbSab_5" className='add-only' value="SabTwo_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabThree_5" name="rbSab_5" className='add-only' value="SabThree_5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Response to Accusation</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabZero_6" name="rbSab_6" className='add-only' value="SabZero_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabOne_6" name="rbSab_6" className='add-only' value="SabOne_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabTwo_6" name="rbSab_6" className='add-only' value="SabTwo_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSabThree_6" name="rbSab_6" className='add-only' value="SabThree_6" />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Adjustment</span>
                </p>
                <table>
                    <tr>
                        <td className='w-390'>&nbsp;</td>
                        <td className='w-90'><strong>0</strong></td>
                        <td className='w-90'><strong>1</strong></td>
                        <td className='w-90'><strong>2</strong></td>
                        <td className='w-90'><strong>3</strong></td>
                    </tr>
                    <tr>
                        <td className='w-390'>Affect Regulation</td>
                        <td className='w-90'>
                            <input type="radio" id="rbAdjustmentZero_1" name="rbAdjustment_1" className='add-only' value="AdjustmentZero_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAdjustmentOne_1" name="rbAdjustment_1" className='add-only' value="AdjustmentOne_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAdjustmentTwo_1" name="rbAdjustment_1" className='add-only' value="AdjustmentTwo_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAdjustmentThree_1" name="rbAdjustment_1" className='add-only' value="AdjustmentThree_1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Intrusions</td>
                        <td className='w-90'>
                            <input type="radio" id="rbAdjustmentZero_2" name="rbAdjustment_2" className='add-only' value="AdjustmentZero_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAdjustmentOne_2" name="rbAdjustment_2" className='add-only' value="AdjustmentOne_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAdjustmentTwo_2" name="rbAdjustment_2" className='add-only' value="AdjustmentTwo_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAdjustmentThree_2" name="rbAdjustment_2" className='add-only' value="AdjustmentThree_2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Attachment</td>
                        <td className='w-90'>
                            <input type="radio" id="rbAdjustmentZero_3" name="rbAdjustment_3" className='add-only' value="AdjustmentZero_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAdjustmentOne_3" name="rbAdjustment_3" className='add-only' value="AdjustmentOne_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAdjustmentTwo_3" name="rbAdjustment_3" className='add-only' value="AdjustmentTwo_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAdjustmentThree_3" name="rbAdjustment_3" className='add-only' value="AdjustmentThree_3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Dissociation</td>
                        <td className='w-90'>
                            <input type="radio" id="rbAdjustmentZero_4" name="rbAdjustment_4" className='add-only' value="AdjustmentZero_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAdjustmentOne_4" name="rbAdjustment_4" className='add-only' value="AdjustmentOne_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAdjustmentTwo_4" name="rbAdjustment_4" className='add-only' value="AdjustmentTwo_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbAdjustmentThree_4" name="rbAdjustment_4" className='add-only' value="AdjustmentThree_4" />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>CRIME</span>
                </p>
                <table>
                    <tr>
                        <td className='w-390'>&nbsp;</td>
                        <td className='w-90'><strong>0</strong></td>
                        <td className='w-90'><strong>1</strong></td>
                        <td className='w-90'><strong>2</strong></td>
                        <td className='w-90'><strong>3</strong></td>
                    </tr>
                    <tr>
                        <td className='w-390'>Seriousness</td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeZero_1" name="rbCrime_1" className='add-only' value="CrimeZero_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeOne_1" name="rbCrime_1" className='add-only' value="CrimeOne_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeTwo_1" name="rbCrime_1" className='add-only' value="CrimeTwo_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeThree_1" name="rbCrime_1" className='add-only' value="CrimeThree_1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>History</td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeZero_2" name="rbCrime_2" className='add-only' value="CrimeZero_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeOne_2" name="rbCrime_2" className='add-only' value="CrimeOne_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeTwo_2" name="rbCrime_2" className='add-only' value="CrimeTwo_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeThree_2" name="rbCrime_2" className='add-only' value="CrimeThree_2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Arrests</td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeZero_3" name="rbCrime_3" className='add-only' value="CrimeZero_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeOne_3" name="rbCrime_3" className='add-only' value="CrimeOne_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeTwo_3" name="rbCrime_3" className='add-only' value="CrimeTwo_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeThree_3" name="rbCrime_3" className='add-only' value="CrimeThree_3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Planning</td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeZero_4" name="rbCrime_4" className='add-only' value="CrimeZero_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeOne_4" name="rbCrime_4" className='add-only' value="CrimeOne_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeTwo_4" name="rbCrime_4" className='add-only' value="CrimeTwo_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeThree_4" name="rbCrime_4" className='add-only' value="CrimeThree_4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Community Safety</td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeZero_5" name="rbCrime_5" className='add-only' value="CrimeZero_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeOne_5" name="rbCrime_5" className='add-only' value="CrimeOne_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeTwo_5" name="rbCrime_5" className='add-only' value="CrimeTwo_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeThree_5" name="rbCrime_5" className='add-only' value="CrimeThree_5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Legal Compliance</td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeZero_6" name="rbCrime_6" className='add-only' value="CrimeZero_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeOne_6" name="rbCrime_6" className='add-only' value="CrimeOne_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeTwo_6" name="rbCrime_6" className='add-only' value="CrimeTwo_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeThree_6" name="rbCrime_6" className='add-only' value="CrimeThree_6" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Peer Influences</td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeZero_7" name="rbCrime_7" className='add-only' value="CrimeZero_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeOne_7" name="rbCrime_7" className='add-only' value="CrimeOne_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeTwo_7" name="rbCrime_7" className='add-only' value="CrimeTwo_7" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeThree_7" name="rbCrime_7" className='add-only' value="CrimeThree_7" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Environmental Influences</td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeZero_8" name="rbCrime_8" className='add-only' value="CrimeZero_8" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeOne_8" name="rbCrime_8" className='add-only' value="CrimeOne_8" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeTwo_8" name="rbCrime_8" className='add-only' value="CrimeTwo_8" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbCrimeThree_8" name="rbCrime_8" className='add-only' value="CrimeThree_8" />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>SUBSTANCE USE  (SUD)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-390'>&nbsp;</td>
                        <td className='w-90'><strong>0</strong></td>
                        <td className='w-90'><strong>1</strong></td>
                        <td className='w-90'><strong>2</strong></td>
                        <td className='w-90'><strong>3</strong></td>
                    </tr>
                    <tr>
                        <td className='w-390'>Severity of Use</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudZero_1" name="rbSud_1" className='add-only' value="SudZero_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudOne_1" name="rbSud_1" className='add-only' value="SudOne_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudTwo_1" name="rbSud_1" className='add-only' value="SudTwo_1" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudThree_1" name="rbSud_1" className='add-only' value="SudThree_1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Duration of Use</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudZero_2" name="rbSud_2" className='add-only' value="SudZero_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudOne_2" name="rbSud_2" className='add-only' value="SudOne_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudTwo_2" name="rbSud_2" className='add-only' value="SudTwo_2" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudThree_2" name="rbSud_2" className='add-only' value="SudThree_2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Stage of Recovery</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudZero_3" name="rbSud_3" className='add-only' value="SudZero_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudOne_3" name="rbSud_3" className='add-only' value="SudOne_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudTwo_3" name="rbSud_3" className='add-only' value="SudTwo_3" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudThree_3" name="rbSud_3" className='add-only' value="SudThree_3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Peer Influences</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudZero_4" name="rbSud_4" className='add-only' value="SudZero_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudOne_4" name="rbSud_4" className='add-only' value="SudOne_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudTwo_4" name="rbSud_4" className='add-only' value="SudTwo_4" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudThree_4" name="rbSud_4" className='add-only' value="SudThree_4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Environmental Influences</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudZero_5" name="rbSud_5" className='add-only' value="SudZero_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudOne_5" name="rbSud_5" className='add-only' value="SudOne_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudTwo_5" name="rbSud_5" className='add-only' value="SudTwo_5" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudThree_5" name="rbSud_5" className='add-only' value="SudThree_5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>Recovery Support in Community</td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudZero_6" name="rbSud_6" className='add-only' value="SudZero_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudOne_6" name="rbSud_6" className='add-only' value="SudOne_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudTwo_6" name="rbSud_6" className='add-only' value="SudTwo_6" />
                        </td>
                        <td className='w-90'>
                            <input type="radio" id="rbSudThree_6" name="rbSud_6" className='add-only' value="SudThree_6" />
                        </td>
                    </tr>
                </table>
                <h3>Y.	RECOMMENDED SERVICES :</h3>
                <p>
                    <span className='small'>(select all that apply)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbServices_1" name="cbServices_1" className='add-only' value="Services_1" />
                        </td>
                        <td className='w-700'>Individual Therapy (90832, 90834, 90837)</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbServices_2" name="cbServices_2" className='add-only' value="Services_2" />
                        </td>
                        <td className='w-700'>Family Therapy (90846, 90847, H0004)</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbServices_3" name="cbServices_3" className='add-only' value="Services_3" />
                        </td>
                        <td className='w-700'>PP Adult Individual Skills Training (H2017)</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbServices_4" name="cbServices_4" className='add-only' value="Services_4" />
                        </td>
                        <td className='w-700'>PP Adult Family Skills Training (H2014)</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbServices_5" name="cbServices_5" className='add-only' value="Services_5" />
                        </td>
                        <td className='w-700'>Addictive Disease Support Services (H2015HF) Adult Medicaid Only – Requested only if SA dx is present</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbServices_6" name="cbServices_6" className='add-only' value="Services_6" />
                        </td>
                        <td className='w-700'>Case Management (T1016) Medicaid Only </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbServices_7" name="cbServices_7" className='add-only' value="Services_7" />
                        </td>
                        <td className='w-700'>Peer Support Services (H0038, H0038HQ)</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbServices_8" name="cbServices_8" className='add-only' value="Services_8" />
                        </td>
                        <td className='w-700'>Group Therapy (H0004HQ) Adult Medicaid Only</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" id="cbServices_9" name="cbServices_9" className='add-only' value="Services_9" />
                        </td>
                        <td className='w-700'>Medication Management </td>
                    </tr>
                </table>
                <h3>TRANSITION /DISCHARGE PLAN</h3>
                <h3>(Step down service should be a non-CORE related service [i.e., Med Mgmt., Support Group, Mentoring Program etc.]) </h3>
                <h2>Must be written in S.M.A.R.T format</h2>
                <p>
                    <span className='eleHeader'>Projected Date of Discharge/Transition: </span>
                    <input type="text" id="txtProjectedDate" name="txtProjectedDate" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Anticipated Step Down Service:</span>
                    <textarea id="txtAnticipated" name="txtAnticipated" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Plans for Transition/Discharge: </span>
                    <textarea id="txtPlansTransition" name="txtPlansTransition" className='add-only'></textarea>
                </p>
                <h3>COMPLETED BY:</h3>
                <p>
                    <span className='small'>(Please include credentials after your name)</span>
                </p>

                <table>
                    <tr>
                        <td className='w-375 signature' >&nbsp;</td>
                        <td className='w-375 signature'  >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'>Assessor Signature:</td>
                        <td className='small'>Date:</td>
                    </tr>
                    <tr>
                        <td className='w-375 signature'  >&nbsp;</td>
                        <td className='w-375 signature'  >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'>Assessor Print Name:</td>
                        <td className='small'>Date:</td>
                    </tr>
                </table>
                <h3>REVIEWED BY (If Applicable):</h3>
                <p>
                    <span className='small'>(Please include credentials after your name)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375 signature'  >&nbsp;</td>
                        <td className='w-375 signature'  >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'>Licensed Professional Signature:</td>
                        <td className='small'>Date:</td>
                    </tr>
                    <tr>
                        <td className='w-375 signature'  >&nbsp;</td>
                        <td className='w-375 signature'  >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'>Licensed Professional Print Name:</td>
                        <td className='small'>Date:</td>
                    </tr>
                </table>



            </div>
        </form>

    )
}